import React from 'react'

const Icon = ({ name, color, fill }) => {
  switch (name) {
    case 'hollow-star':
      return (
        <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M7.8951 0.97117C7.92797 0.904766 7.97874 0.84887 8.04169 0.809789C8.10464 0.770709 8.17726 0.75 8.25135 0.75C8.32544 0.75 8.39806 0.770709 8.46101 0.809789C8.52396 0.84887 8.57473 0.904766 8.6076 0.97117L10.3401 4.48042C10.4542 4.7114 10.6227 4.91123 10.8311 5.06276C11.0394 5.21429 11.2814 5.313 11.5363 5.35042L15.4109 5.91742C15.4843 5.92806 15.5532 5.95902 15.61 6.00682C15.6667 6.05462 15.7089 6.11733 15.7319 6.18788C15.7548 6.25842 15.7576 6.33398 15.7398 6.406C15.722 6.47802 15.6845 6.54363 15.6314 6.59542L12.8294 9.32392C12.6446 9.504 12.5063 9.72628 12.4265 9.97164C12.3466 10.217 12.3276 10.4781 12.3711 10.7324L13.0326 14.5874C13.0456 14.6608 13.0376 14.7363 13.0097 14.8054C12.9818 14.8745 12.935 14.9344 12.8748 14.9782C12.8145 15.022 12.7431 15.0479 12.6687 15.0531C12.5944 15.0583 12.5201 15.0424 12.4543 15.0074L8.99085 13.1864C8.76264 13.0666 8.50873 13.004 8.25097 13.004C7.99322 13.004 7.73931 13.0666 7.5111 13.1864L4.04835 15.0074C3.9826 15.0422 3.9084 15.0579 3.83419 15.0526C3.75998 15.0473 3.68874 15.0213 3.62857 14.9776C3.5684 14.9338 3.52172 14.8741 3.49384 14.8051C3.46596 14.7361 3.45799 14.6607 3.47085 14.5874L4.1316 10.7332C4.17525 10.4787 4.15634 10.2175 4.0765 9.97196C3.99667 9.72644 3.85831 9.50404 3.67335 9.32392L0.87135 6.59617C0.817795 6.54444 0.779845 6.47872 0.761822 6.40648C0.743799 6.33423 0.746427 6.25838 0.769409 6.18756C0.79239 6.11674 0.8348 6.0538 0.891807 6.00591C0.948815 5.95801 1.01813 5.92709 1.09185 5.91667L4.9656 5.35042C5.22079 5.31329 5.46314 5.21471 5.67179 5.06316C5.88043 4.91161 6.04913 4.71162 6.16335 4.48042L7.8951 0.97117Z' stroke='#DCDCDC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
        </svg>
      )
    case 'tenant-inactive':
      return (
        <svg
          width='208'
          height='208'
          viewBox='0 0 208 208'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M138.742 199.176C171.917 199.176 198.811 172.283 198.811 139.108C198.811 105.933 171.917 79.04 138.742 79.04C105.568 79.04 78.6743 105.933 78.6743 139.108C78.6743 172.283 105.568 199.176 138.742 199.176Z'
            fill='#57D08A'
          />
          <path
            d='M159.526 159.892C156.797 162.622 153.557 164.787 149.991 166.264C146.425 167.742 142.603 168.502 138.743 168.502C134.883 168.502 131.06 167.742 127.494 166.264C123.928 164.787 120.688 162.622 117.959 159.892'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M117.959 118.325C120.688 115.595 123.928 113.429 127.494 111.952C131.06 110.474 134.883 109.714 138.743 109.714C142.603 109.714 146.425 110.474 149.991 111.952C153.557 113.429 156.797 115.595 159.526 118.325'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M138.742 144.218C141.565 144.218 143.853 141.93 143.853 139.108C143.853 136.285 141.565 133.997 138.742 133.997C135.92 133.997 133.632 136.285 133.632 139.108C133.632 141.93 135.92 144.218 138.742 144.218Z'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M185.729 92.1211L176.694 101.156'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M100.791 177.06L91.7476 186.095'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M185.729 186.095L176.694 177.06'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M138.288 173.802V161.021'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M138.288 116.293V103.513'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M103.147 138.653H115.928'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M160.656 138.653H173.436'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M100.791 101.156L91.7476 92.1211'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M72.2881 139.108H85.0687'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M192.416 139.108H205.197'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M72.2881 139.108H85.0687'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M192.416 139.108H205.197'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M138.743 72.6533V85.4339'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M138.743 192.782V205.563'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M105.308 173.818C106.012 173.818 106.583 173.247 106.583 172.542C106.583 171.838 106.012 171.267 105.308 171.267C104.603 171.267 104.032 171.838 104.032 172.542C104.032 173.247 104.603 173.818 105.308 173.818Z'
            fill='#2C2B69'
          />
          <path
            d='M108.916 170.203C109.62 170.203 110.191 169.632 110.191 168.927C110.191 168.222 109.62 167.651 108.916 167.651C108.211 167.651 107.64 168.222 107.64 168.927C107.64 169.632 108.211 170.203 108.916 170.203Z'
            fill='#2C2B69'
          />
          <path
            d='M112.531 166.586C113.236 166.586 113.807 166.015 113.807 165.311C113.807 164.606 113.236 164.035 112.531 164.035C111.827 164.035 111.256 164.606 111.256 165.311C111.256 166.015 111.827 166.586 112.531 166.586Z'
            fill='#2C2B69'
          />
          <path
            d='M164.044 115.082C164.748 115.082 165.319 114.511 165.319 113.807C165.319 113.102 164.748 112.531 164.044 112.531C163.339 112.531 162.768 113.102 162.768 113.807C162.768 114.511 163.339 115.082 164.044 115.082Z'
            fill='#2C2B69'
          />
          <path
            d='M167.659 111.467C168.364 111.467 168.935 110.896 168.935 110.192C168.935 109.487 168.364 108.916 167.659 108.916C166.955 108.916 166.384 109.487 166.384 110.192C166.384 110.896 166.955 111.467 167.659 111.467Z'
            fill='#2C2B69'
          />
          <path
            d='M171.275 107.851C171.98 107.851 172.551 107.28 172.551 106.575C172.551 105.871 171.98 105.3 171.275 105.3C170.571 105.3 170 105.871 170 106.575C170 107.28 170.571 107.851 171.275 107.851Z'
            fill='#2C2B69'
          />
          <path
            d='M105.308 107.851C106.013 107.851 106.584 107.28 106.584 106.575C106.584 105.871 106.013 105.3 105.308 105.3C104.604 105.3 104.033 105.871 104.033 106.575C104.033 107.28 104.604 107.851 105.308 107.851Z'
            fill='#2C2B69'
          />
          <path
            d='M108.916 111.467C109.62 111.467 110.191 110.896 110.191 110.192C110.191 109.487 109.62 108.916 108.916 108.916C108.211 108.916 107.64 109.487 107.64 110.192C107.64 110.896 108.211 111.467 108.916 111.467Z'
            fill='#2C2B69'
          />
          <path
            d='M112.531 115.082C113.236 115.082 113.807 114.511 113.807 113.807C113.807 113.102 113.236 112.531 112.531 112.531C111.827 112.531 111.256 113.102 111.256 113.807C111.256 114.511 111.827 115.082 112.531 115.082Z'
            fill='#2C2B69'
          />
          <path
            d='M164.044 166.586C164.748 166.586 165.319 166.015 165.319 165.311C165.319 164.606 164.748 164.035 164.044 164.035C163.339 164.035 162.768 164.606 162.768 165.311C162.768 166.015 163.339 166.586 164.044 166.586Z'
            fill='#2C2B69'
          />
          <path
            d='M167.659 170.203C168.364 170.203 168.935 169.632 168.935 168.927C168.935 168.222 168.364 167.651 167.659 167.651C166.955 167.651 166.384 168.222 166.384 168.927C166.384 169.632 166.955 170.203 167.659 170.203Z'
            fill='#2C2B69'
          />
          <path
            d='M171.275 173.818C171.98 173.818 172.551 173.247 172.551 172.542C172.551 171.838 171.98 171.267 171.275 171.267C170.571 171.267 170 171.838 170 172.542C170 173.247 170.571 173.818 171.275 173.818Z'
            fill='#2C2B69'
          />
          <path
            d='M145.064 145.437L142.358 142.724'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M135.127 135.493L132.413 132.787'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M132.413 145.437L135.127 142.724'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M142.358 135.493L145.064 132.787'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M82.4443 3.98926C90.3825 3.98926 90.3825 10.3918 98.3206 10.3918C106.259 10.3918 106.267 3.98926 114.205 3.98926C122.143 3.98926 122.143 10.3918 130.081 10.3918C138.019 10.3918 138.019 3.98926 145.957 3.98926C153.896 3.98926 153.904 10.3918 161.842 10.3918C169.78 10.3918 169.812 3.98926 177.726 3.98926'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M82.4443 44.249C90.3825 44.249 90.3825 50.6515 98.3206 50.6515C106.259 50.6515 106.267 44.249 114.205 44.249C122.143 44.249 122.143 50.6515 130.081 50.6515C138.019 50.6515 138.019 44.249 145.957 44.249C153.896 44.249 153.904 50.6515 161.842 50.6515C169.78 50.6515 169.78 44.249 177.726 44.249'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M92.3733 20.2149L86.6045 15.998L81.0552 20.2149V36.2049H92.3733V20.2149ZM85.4914 19.1018C85.4914 18.8816 85.5567 18.6664 85.679 18.4834C85.8013 18.3003 85.9752 18.1577 86.1786 18.0734C86.382 17.9892 86.6058 17.9671 86.8217 18.0101C87.0376 18.053 87.236 18.159 87.3917 18.3147C87.5473 18.4704 87.6533 18.6687 87.6963 18.8846C87.7392 19.1006 87.7172 19.3244 87.6329 19.5278C87.5487 19.7312 87.406 19.905 87.223 20.0273C87.0399 20.1496 86.8247 20.2149 86.6045 20.2149C86.4581 20.216 86.3128 20.1879 86.1773 20.1324C86.0418 20.0768 85.9186 19.9949 85.815 19.8913C85.7115 19.7877 85.6295 19.6646 85.574 19.529C85.5184 19.3935 85.4903 19.2483 85.4914 19.1018Z'
            fill='#57D08A'
          />
          <path
            d='M106.787 20.2149L101.01 15.998L95.4604 20.2149V36.2049H106.787V20.2149ZM99.9373 19.1018C99.9373 18.8816 100.003 18.6664 100.125 18.4834C100.247 18.3003 100.421 18.1577 100.624 18.0734C100.828 17.9892 101.052 17.9671 101.268 18.0101C101.484 18.053 101.682 18.159 101.838 18.3147C101.993 18.4704 102.099 18.6687 102.142 18.8846C102.185 19.1006 102.163 19.3244 102.079 19.5278C101.995 19.7312 101.852 19.905 101.669 20.0273C101.486 20.1496 101.271 20.2149 101.05 20.2149C100.904 20.216 100.759 20.1879 100.623 20.1324C100.488 20.0768 100.365 19.9949 100.261 19.8913C100.157 19.7877 100.075 19.6646 100.02 19.529C99.9643 19.3935 99.9362 19.2483 99.9373 19.1018Z'
            fill='#57D08A'
          />
          <path
            d='M121.201 20.2149L115.424 15.998L109.875 20.2149V36.2049H121.201V20.2149ZM114.319 19.1018C114.319 18.8813 114.384 18.6658 114.507 18.4825C114.63 18.2993 114.804 18.1567 115.008 18.0726C115.212 17.9886 115.436 17.9671 115.652 18.0107C115.868 18.0543 116.067 18.1611 116.222 18.3176C116.377 18.4741 116.483 18.6732 116.525 18.8897C116.567 19.1061 116.544 19.3302 116.458 19.5334C116.373 19.7367 116.229 19.91 116.045 20.0313C115.86 20.1526 115.644 20.2165 115.424 20.2149C115.278 20.2149 115.134 20.1861 114.999 20.13C114.865 20.074 114.742 19.9919 114.64 19.8884C114.537 19.7849 114.456 19.6622 114.401 19.5272C114.346 19.3922 114.318 19.2476 114.319 19.1018Z'
            fill='#57D08A'
          />
          <path
            d='M128.887 24.0011H148.354V17.5986H167.57'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M168.366 21.604C170.578 21.604 172.372 19.8106 172.372 17.5984C172.372 15.3862 170.578 13.5928 168.366 13.5928C166.154 13.5928 164.36 15.3862 164.36 17.5984C164.36 19.8106 166.154 21.604 168.366 21.604Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M158.762 28.8111C160.975 28.8111 162.768 27.0177 162.768 24.8054C162.768 22.5932 160.975 20.7998 158.762 20.7998C156.55 20.7998 154.757 22.5932 154.757 24.8054C154.757 27.0177 156.55 28.8111 158.762 28.8111Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M125.677 28.8113H140.895V36.01H152.352V24.8057H154.757'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M132.088 32.8086V40.8198H157.958V36.8142H163.565'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M166.766 40.8198C168.978 40.8198 170.771 39.0265 170.771 36.8142C170.771 34.602 168.978 32.8086 166.766 32.8086C164.554 32.8086 162.76 34.602 162.76 36.8142C162.76 39.0265 164.554 40.8198 166.766 40.8198Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M165.433 61.9043V69.4362'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M200.582 61.9043V80.3155'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M200.582 61.9043V69.4362H161.249'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M200.582 65.2516C202.893 65.2516 204.766 63.3782 204.766 61.0672C204.766 58.7562 202.893 56.8828 200.582 56.8828C198.271 56.8828 196.397 58.7562 196.397 61.0672C196.397 63.3782 198.271 65.2516 200.582 65.2516Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M165.433 65.2516C167.744 65.2516 169.618 63.3782 169.618 61.0672C169.618 58.7562 167.744 56.8828 165.433 56.8828C163.122 56.8828 161.249 58.7562 161.249 61.0672C161.249 63.3782 163.122 65.2516 165.433 65.2516Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M183.007 61.9043V69.4362'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M183.008 65.2516C185.319 65.2516 187.192 63.3782 187.192 61.0672C187.192 58.7562 185.319 56.8828 183.008 56.8828C180.697 56.8828 178.823 58.7562 178.823 61.0672C178.823 63.3782 180.697 65.2516 183.008 65.2516Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M200.582 84.4996C202.893 84.4996 204.766 82.6262 204.766 80.3152C204.766 78.0043 202.893 76.1309 200.582 76.1309C198.271 76.1309 196.397 78.0043 196.397 80.3152C196.397 82.6262 198.271 84.4996 200.582 84.4996Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M193.643 29.2666H191.189V36.2622H193.643V29.2666Z'
            fill='#2C2B69'
          />
          <path
            d='M192.416 29.9327C199.134 29.9327 204.579 24.4871 204.579 17.7696C204.579 11.0521 199.134 5.60645 192.416 5.60645C185.699 5.60645 180.253 11.0521 180.253 17.7696C180.253 24.4871 185.699 29.9327 192.416 29.9327Z'
            fill='#57D08A'
          />
          <path
            d='M192.416 29.9327C199.134 29.9327 204.579 24.4871 204.579 17.7696C204.579 11.0521 199.134 5.60645 192.416 5.60645C185.699 5.60645 180.253 11.0521 180.253 17.7696C180.253 24.4871 185.699 29.9327 192.416 29.9327Z'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M192.416 27.1779C197.612 27.1779 201.825 22.9654 201.825 17.7691C201.825 12.5728 197.612 8.36035 192.416 8.36035C187.22 8.36035 183.007 12.5728 183.007 17.7691C183.007 22.9654 187.22 27.1779 192.416 27.1779Z'
            fill='#2C2B69'
          />
          <path
            d='M185.25 17.7694C185.25 16.5173 185.578 15.287 186.201 14.2009C186.824 13.1148 187.72 12.2105 188.801 11.5781'
            stroke='#DCD7F5'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M192.416 32.4756H192.408C190.698 32.4756 189.312 33.8615 189.312 35.5712V42.5018C189.312 44.2115 190.698 45.5975 192.408 45.5975H192.416C194.126 45.5975 195.512 44.2115 195.512 42.5018V35.5712C195.512 33.8615 194.126 32.4756 192.416 32.4756Z'
            fill='#57D08A'
          />
          <path
            d='M192.416 32.4756H192.408C190.698 32.4756 189.312 33.8615 189.312 35.5712V42.5018C189.312 44.2115 190.698 45.5975 192.408 45.5975H192.416C194.126 45.5975 195.512 44.2115 195.512 42.5018V35.5712C195.512 33.8615 194.126 32.4756 192.416 32.4756Z'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M59.8734 4.68783C60.4695 4.09086 61.1775 3.61726 61.9569 3.29413C62.7362 2.97101 63.5716 2.80469 64.4153 2.80469C65.2589 2.80469 66.0943 2.97101 66.8737 3.29413C67.653 3.61726 68.361 4.09086 68.9571 4.68783C69.9161 5.64547 70.5474 6.88207 70.7604 8.22046C70.9735 9.55885 70.7575 10.9303 70.1434 12.1385L66.1378 20.0278C65.9779 20.3478 65.732 20.6169 65.4278 20.8049C65.1235 20.993 64.7729 21.0926 64.4153 21.0926C64.0576 21.0926 63.707 20.993 63.4027 20.8049C63.0985 20.6169 62.8527 20.3478 62.6928 20.0278L58.6871 12.1385C58.073 10.9303 57.857 9.55885 58.0701 8.22046C58.2832 6.88207 58.9144 5.64547 59.8734 4.68783Z'
            fill='#57D08A'
          />
          <path
            d='M64.4148 11.9517C66.1155 11.9517 67.4942 10.573 67.4942 8.87234C67.4942 7.17165 66.1155 5.79297 64.4148 5.79297C62.7141 5.79297 61.3354 7.17165 61.3354 8.87234C61.3354 10.573 62.7141 11.9517 64.4148 11.9517Z'
            fill='#2C2B69'
          />
          <path
            d='M59.8729 27.9583C60.4691 27.3614 61.1771 26.8878 61.9564 26.5646C62.7357 26.2415 63.5711 26.0752 64.4148 26.0752C65.2585 26.0752 66.0939 26.2415 66.8732 26.5646C67.6525 26.8878 68.3605 27.3614 68.9567 27.9583C69.915 28.9147 70.5459 30.1499 70.759 31.4869C70.9721 32.8238 70.7564 34.194 70.1429 35.4008L66.1373 43.2983C65.9753 43.6158 65.7287 43.8824 65.4247 44.0686C65.1208 44.2547 64.7713 44.3532 64.4148 44.3532C64.0584 44.3532 63.7088 44.2547 63.4049 44.0686C63.1009 43.8824 62.8543 43.6158 62.6923 43.2983L58.6867 35.4008C58.0732 34.194 57.8575 32.8238 58.0706 31.4869C58.2837 30.1499 58.9146 28.9147 59.8729 27.9583Z'
            fill='#57D08A'
          />
          <path
            d='M64.4148 35.2134C66.1155 35.2134 67.4942 33.8348 67.4942 32.1341C67.4942 30.4334 66.1155 29.0547 64.4148 29.0547C62.7141 29.0547 61.3354 30.4334 61.3354 32.1341C61.3354 33.8348 62.7141 35.2134 64.4148 35.2134Z'
            fill='#2C2B69'
          />
          <path
            d='M6.7926 28.8027H2.80322'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M55.5428 28.8027H51.5615'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M29.1768 6.42687V2.4375'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.3496 12.9753L10.5303 10.1641'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M47.8238 47.4502L45.0044 44.6309'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M45.0044 12.9753L47.8238 10.1641'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.5298 47.4502L13.3492 44.6309'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M27.0969 10.1479C23.6329 10.5519 20.3609 11.9532 17.6782 14.1815C14.9955 16.4099 13.0177 19.3694 11.9851 22.7004C10.9525 26.0315 10.9095 29.5907 11.8613 32.9458C12.8132 36.3008 14.7189 39.3072 17.3469 41.5997C19.5822 43.5295 21.2035 46.0716 22.0107 48.9122H36.3513C37.124 46.1056 38.7168 43.5934 40.9257 41.6972C43.846 39.1841 45.8831 35.8005 46.7377 32.0436C47.5923 28.2868 47.2193 24.3549 45.6734 20.8258C44.1276 17.2968 41.4905 14.3566 38.1496 12.4375C34.8088 10.5184 30.9405 9.72157 27.1132 10.1641L27.0969 10.1479Z'
            fill='#57D08A'
          />
          <path
            d='M36.3511 48.8966C37.1239 46.0899 38.7166 43.5777 40.9255 41.6816C43.8458 39.1685 45.883 35.7849 46.7376 32.028C47.5922 28.2712 47.2191 24.3393 45.6733 20.8102C44.1274 17.2811 41.4903 14.341 38.1495 12.4219C34.8087 10.5028 30.9403 9.70595 27.113 10.1485V10.1485C23.6491 10.5525 20.377 11.9538 17.6943 14.1821C15.0116 16.4105 13.0338 19.37 12.0012 22.701C10.9686 26.0321 10.9256 29.5914 11.8774 32.9464C12.8293 36.3014 14.735 39.3078 17.363 41.6004C19.5983 43.5301 21.2196 46.0722 22.0268 48.9129'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M37.708 47.9377H20.6861C20.4613 47.9327 20.2417 48.0063 20.0653 48.1457C19.8888 48.2851 19.7664 48.4816 19.7192 48.7015C19.6917 48.8389 19.6949 48.9808 19.7286 49.1169C19.7623 49.253 19.8256 49.3799 19.9142 49.4886C20.0027 49.5973 20.1142 49.6851 20.2406 49.7457C20.367 49.8063 20.5053 49.8381 20.6455 49.839H20.6861C21.1346 49.8386 21.5672 50.0045 21.9004 50.3047C22.2336 50.6049 22.4436 51.0179 22.4899 51.464C22.4899 51.8621 22.5467 52.2765 22.5467 52.6665V58.354C22.5467 58.8561 22.7462 59.3376 23.1012 59.6926C23.4563 60.0477 23.9378 60.2471 24.4399 60.2471H33.9217C34.4238 60.2471 34.9054 60.0477 35.2604 59.6926C35.6154 59.3376 35.8149 58.8561 35.8149 58.354V52.6665C35.8132 52.2676 35.8321 51.869 35.8717 51.4721C35.918 51.0261 36.128 50.613 36.4612 50.3128C36.7944 50.0127 37.227 49.8467 37.6755 49.8471C37.8999 49.8506 38.1187 49.7765 38.2949 49.6373C38.471 49.4982 38.5938 49.3025 38.6424 49.0834C38.6699 48.9448 38.6665 48.8019 38.6324 48.6649C38.5982 48.5278 38.5343 48.4 38.445 48.2905C38.3557 48.181 38.2433 48.0927 38.1159 48.0317C37.9885 47.9707 37.8492 47.9386 37.708 47.9377Z'
            fill='#57D08A'
          />
          <path
            d='M37.708 47.9377H20.6861C20.4613 47.9327 20.2417 48.0063 20.0653 48.1457C19.8888 48.2851 19.7664 48.4816 19.7192 48.7015C19.6917 48.8389 19.6949 48.9808 19.7286 49.1169C19.7623 49.253 19.8256 49.3799 19.9142 49.4886C20.0027 49.5973 20.1142 49.6851 20.2406 49.7457C20.367 49.8063 20.5053 49.8381 20.6455 49.839H20.6861C21.1346 49.8386 21.5672 50.0045 21.9004 50.3047C22.2336 50.6049 22.4436 51.0179 22.4899 51.464C22.4899 51.8621 22.5467 52.2765 22.5467 52.6665V58.354C22.5467 58.8561 22.7462 59.3376 23.1012 59.6926C23.4563 60.0477 23.9378 60.2471 24.4399 60.2471H33.9217C34.4238 60.2471 34.9054 60.0477 35.2604 59.6926C35.6154 59.3376 35.8149 58.8561 35.8149 58.354V52.6665C35.8132 52.2676 35.8321 51.869 35.8717 51.4721C35.918 51.0261 36.128 50.613 36.4612 50.3128C36.7944 50.0127 37.227 49.8467 37.6755 49.8471V49.8471C37.8999 49.8506 38.1187 49.7765 38.2949 49.6373C38.471 49.4982 38.5938 49.3025 38.6424 49.0834C38.6699 48.9448 38.6665 48.8019 38.6324 48.6649C38.5982 48.5278 38.5343 48.4 38.445 48.2905C38.3557 48.181 38.2433 48.0927 38.1159 48.0317C37.9885 47.9707 37.8492 47.9386 37.708 47.9377V47.9377Z'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.333 60.2715H32.0205V61.2221C32.0205 61.9763 31.7209 62.6996 31.1876 63.2329C30.6543 63.7663 29.931 64.0659 29.1768 64.0659C28.4225 64.0659 27.6992 63.7663 27.1659 63.2329C26.6326 62.6996 26.333 61.9763 26.333 61.2221V60.2715Z'
            fill='#57D08A'
          />
          <path
            d='M26.333 60.2715H32.0205V61.2221C32.0205 61.9763 31.7209 62.6996 31.1876 63.2329C30.6543 63.7663 29.931 64.0659 29.1768 64.0659C28.4225 64.0659 27.6992 63.7663 27.1659 63.2329C26.6326 62.6996 26.333 61.9763 26.333 61.2221V60.2715Z'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.2793 53.1208L37.058 51.9102'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.2793 57.3298L37.058 56.1191'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.4874 43.5911L23.6031 25.9111C23.5192 25.4044 23.5468 24.8856 23.6839 24.3907C23.821 23.8958 24.0643 23.4368 24.3968 23.0455C24.7293 22.6541 25.1431 22.34 25.6094 22.1249C26.0757 21.9098 26.5833 21.7988 27.0968 21.7998H31.2649C31.778 21.8002 32.2849 21.9121 32.7505 22.1276C33.2161 22.3432 33.6293 22.6573 33.9616 23.0483C34.2938 23.4393 34.5372 23.8978 34.6748 24.3921C34.8124 24.8864 34.8411 25.4046 34.7587 25.9111L31.8662 43.5911'
            stroke='#DCD7F5'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.4283 100.197C24.7426 100.197 30.6721 94.268 30.6721 86.9537C30.6721 79.6394 24.7426 73.71 17.4283 73.71C10.114 73.71 4.18457 79.6394 4.18457 86.9537C4.18457 94.268 10.114 100.197 17.4283 100.197Z'
            fill='#57D08A'
          />
          <path
            d='M17.4282 96.9961C22.9746 96.9961 27.4707 92.5 27.4707 86.9536C27.4707 81.4073 22.9746 76.9111 17.4282 76.9111C11.8819 76.9111 7.38574 81.4073 7.38574 86.9536C7.38574 92.5 11.8819 96.9961 17.4282 96.9961Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.4283 92.4464C20.5559 92.4464 23.0914 89.9109 23.0914 86.7832C23.0914 83.6556 20.5559 81.1201 17.4283 81.1201C14.3006 81.1201 11.7651 83.6556 11.7651 86.7832C11.7651 89.9109 14.3006 92.4464 17.4283 92.4464Z'
            fill='#DCD7F5'
          />
          <path
            d='M17.4282 73.71V74.6931'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.4282 99.2061V100.189'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M30.6719 86.9541H29.6807'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M5.17582 86.9541H4.18457'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.7883 77.5859L26.0977 78.2847'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8.76711 95.6152L8.06836 96.314'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.7883 96.314L26.0977 95.6152'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8.76711 78.2847L8.06836 77.5859'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.4283 132.453C24.7426 132.453 30.6721 126.524 30.6721 119.21C30.6721 111.895 24.7426 105.966 17.4283 105.966C10.114 105.966 4.18457 111.895 4.18457 119.21C4.18457 126.524 10.114 132.453 17.4283 132.453Z'
            fill='#57D08A'
          />
          <path
            d='M17.4282 129.253C22.9746 129.253 27.4707 124.757 27.4707 119.21C27.4707 113.664 22.9746 109.168 17.4282 109.168C11.8819 109.168 7.38574 113.664 7.38574 119.21C7.38574 124.757 11.8819 129.253 17.4282 129.253Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.4283 124.873C20.5559 124.873 23.0914 122.338 23.0914 119.21C23.0914 116.082 20.5559 113.547 17.4283 113.547C14.3006 113.547 11.7651 116.082 11.7651 119.21C11.7651 122.338 14.3006 124.873 17.4283 124.873Z'
            fill='#DCD7F5'
          />
          <path
            d='M17.4282 105.966V106.957'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.4282 131.463V132.446'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M30.6719 119.21H29.6807'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M5.17582 119.21H4.18457'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.7883 109.842L26.0977 110.541'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8.76711 127.871L8.06836 128.57'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M26.7883 128.57L26.0977 127.871'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8.76711 110.541L8.06836 109.842'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M61.2301 61.4331L58.7276 60.3525L56.2251 61.4331V55.2256H61.2301V61.4331Z'
            fill='#57D08A'
          />
          <path
            d='M61.2301 61.4331L58.7276 60.3525L56.2251 61.4331V55.2256H61.2301V61.4331Z'
            fill='#57D08A'
          />
          <path
            d='M58.7275 58.622C61.7699 58.622 64.2362 56.1556 64.2362 53.1132C64.2362 50.0708 61.7699 47.6045 58.7275 47.6045C55.6851 47.6045 53.2188 50.0708 53.2188 53.1132C53.2188 56.1556 55.6851 58.622 58.7275 58.622Z'
            fill='#2C2B69'
          />
          <path
            d='M58.7273 50.1797L59.6779 52.1053L61.8067 52.4222L60.2711 53.9172L60.6286 56.0378L58.7273 55.0384L56.8261 56.0378L57.1836 53.9172L55.6479 52.4222L57.7767 52.1053L58.7273 50.1797Z'
            fill='#57D08A'
          />
          <path
            d='M74.7906 61.4331L72.2881 60.3525L69.7856 61.4331V55.2256H74.7906V61.4331Z'
            fill='#57D08A'
          />
          <path
            d='M74.7906 61.4331L72.2881 60.3525L69.7856 61.4331V55.2256H74.7906V61.4331Z'
            fill='#57D08A'
          />
          <path
            d='M72.288 58.622C75.3304 58.622 77.7968 56.1556 77.7968 53.1132C77.7968 50.0708 75.3304 47.6045 72.288 47.6045C69.2456 47.6045 66.7793 50.0708 66.7793 53.1132C66.7793 56.1556 69.2456 58.622 72.288 58.622Z'
            fill='#2C2B69'
          />
          <path
            d='M72.2882 50.1797L73.2388 52.1053L75.3676 52.4222L73.8238 53.9172L74.1894 56.0378L72.2882 55.0384L70.3788 56.0378L70.7444 53.9172L69.2007 52.4222L71.3376 52.1053L72.2882 50.1797Z'
            fill='#57D08A'
          />
          <path
            d='M108.233 58.0938H137.361V72.4994'
            stroke='#57D08A'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M88.27 61.4814H97.3863V108.915'
            stroke='#57D08A'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M109.037 62.0991C111.25 62.0991 113.043 60.3058 113.043 58.0935C113.043 55.8813 111.25 54.0879 109.037 54.0879C106.825 54.0879 105.032 55.8813 105.032 58.0935C105.032 60.3058 106.825 62.0991 109.037 62.0991Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M89.0662 65.4878C91.2784 65.4878 93.0718 63.6944 93.0718 61.4822C93.0718 59.2699 91.2784 57.4766 89.0662 57.4766C86.8539 57.4766 85.0605 59.2699 85.0605 61.4822C85.0605 63.6944 86.8539 65.4878 89.0662 65.4878Z'
            fill='#22214B'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M47.8235 203.296C54.3975 203.296 59.7267 197.966 59.7267 191.392C59.7267 184.818 54.3975 179.489 47.8235 179.489C41.2496 179.489 35.9204 184.818 35.9204 191.392C35.9204 197.966 41.2496 203.296 47.8235 203.296Z'
            fill='#57D08A'
          />
          <path
            d='M47.8237 181.488V182.406'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M47.8237 200.387V201.297'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M57.7282 191.393H56.8101'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M38.8294 191.393H37.9194'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M41.4619 197.755L46.2313 189.8L54.1775 185.039L49.4082 192.985L41.4619 197.755Z'
            fill='#2C2B69'
          />
          <path
            d='M29.1689 150.175V144.642H4.69645V150.175H29.1689Z'
            fill='#57D08A'
          />
          <path
            d='M21.1411 159.389V153.855H4.69611V159.389H21.1411Z'
            fill='#57D08A'
          />
          <path
            d='M14.6816 168.601V163.068H4.69602V168.601H14.6816Z'
            fill='#57D08A'
          />
          <path
            d='M24.6675 177.824V172.291H4.69623V177.824H24.6675Z'
            fill='#57D08A'
          />
          <path
            d='M16.6968 187.127V181.594H4.69615V187.127H16.6968Z'
            fill='#57D08A'
          />
          <path
            d='M20.6699 196.349V190.815H4.69617V196.349H20.6699Z'
            fill='#57D08A'
          />
          <path
            d='M24.6675 205.57V200.037H4.69622V205.57H24.6675Z'
            fill='#57D08A'
          />
          <path
            d='M29.1689 150.175V144.642H4.69645V150.175H29.1689Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.1411 159.389V153.855H4.69611V159.389H21.1411Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.6816 168.601V163.068H4.69602V168.601H14.6816Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M24.6675 177.824V172.291H4.69623V177.824H24.6675Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.6968 187.127V181.594H4.69615V187.127H16.6968Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M20.6699 196.349V190.815H4.69617V196.349H20.6699Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M24.6675 205.57V200.037H4.69622V205.57H24.6675Z'
            stroke='#2C2B69'
            strokeWidth='0.99'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M34.1982 79.0965V73.8965'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M40.6006 79.0966V70.2891'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M47.0112 79.0965V73.8965'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M53.4136 79.0966V70.2891'
            stroke='#2C2B69'
            strokeWidth='1.97'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M64.1875 181.074C64.1875 177.995 64.0412 175.151 64.1875 172.324C64.7075 163.386 58.5 157.146 49.5625 157.699C47.125 157.845 44.6225 157.942 42.1443 158.105C41.7524 158.193 41.3416 158.124 40.9998 157.913C40.6581 157.702 40.4127 157.365 40.3162 156.975C38.5287 152.566 36.6789 148.184 34.7668 143.829C34.6591 143.644 34.5889 143.44 34.5604 143.228C34.5319 143.015 34.5456 142.8 34.6007 142.593C34.6558 142.386 34.7512 142.192 34.8815 142.022C35.0118 141.852 35.1744 141.71 35.36 141.603C37.3668 139.856 39.3087 138.044 41.2831 136.232C42.6866 135.004 43.8093 133.488 44.575 131.787C45.3407 130.086 45.7314 128.24 45.7206 126.375C45.7099 124.51 45.2978 122.669 44.5125 120.977C43.7272 119.285 42.587 117.782 41.1693 116.57C39.1381 114.75 37.1068 112.987 35.1162 111.069C34.9013 110.811 34.7491 110.506 34.6716 110.179C34.5941 109.852 34.5933 109.512 34.6693 109.184C36.4027 104.699 38.2227 100.244 40.1293 95.8186C40.3001 95.5311 40.5362 95.2878 40.8185 95.1085C41.1009 94.9292 41.4215 94.819 41.7543 94.7867C44.1918 94.7867 46.5725 94.9167 49.0018 95.0711C58.1181 95.6805 64.3012 89.5299 63.7487 80.4461C63.5618 77.6024 63.4643 74.7586 63.3181 71.7767C68.1931 69.7292 73.125 67.6411 78.065 65.6586C78.3349 65.6118 78.612 65.6286 78.8743 65.7076C79.1367 65.7865 79.377 65.9256 79.5762 66.1136C81.5181 68.1124 83.3706 70.1761 85.2637 72.2642C86.4969 73.6652 88.0172 74.7841 89.7214 75.5451C91.4256 76.306 93.2736 76.6911 95.1399 76.6742C97.0062 76.6572 98.8469 76.2386 100.537 75.4468C102.227 74.655 103.727 73.5086 104.934 72.0855C106.632 70.2005 108.363 68.348 109.988 66.398C110.266 65.9439 110.711 65.6167 111.227 65.4861C111.743 65.3555 112.29 65.432 112.751 65.6992C116.943 67.4949 121.16 69.2499 125.401 70.8911C126.636 71.3542 126.847 72.0367 126.791 73.1742C126.62 76.018 126.409 78.8617 126.409 81.7217C126.404 83.5149 126.769 85.2897 127.483 86.9346C128.197 88.5796 129.244 90.059 130.557 91.28C131.87 92.5009 133.422 93.437 135.115 94.0293C136.807 94.6216 138.604 94.8573 140.392 94.7217L149.792 94.2017C151.881 99.1499 153.944 104.049 155.943 108.989C155.974 109.264 155.944 109.542 155.857 109.804C155.77 110.066 155.628 110.307 155.439 110.509C153.424 112.434 151.32 114.27 149.272 116.196C147.895 117.422 146.794 118.928 146.043 120.612C145.291 122.297 144.907 124.122 144.916 125.966C144.924 127.811 145.325 129.632 146.092 131.31C146.858 132.987 147.973 134.483 149.362 135.696C151.393 137.532 153.481 139.287 155.439 141.189C155.668 141.472 155.831 141.803 155.915 142.157C156 142.511 156.004 142.88 155.927 143.236C154.21 147.667 152.411 152.06 150.532 156.415C150.343 156.727 150.084 156.99 149.775 157.184C149.466 157.377 149.116 157.495 148.752 157.528C146.266 157.528 143.804 157.382 141.326 157.227C132.47 156.715 126.262 162.964 126.864 171.852C127.026 174.29 127.107 176.654 127.294 179.067C127.398 179.521 127.321 179.996 127.08 180.394C126.839 180.791 126.452 181.079 126.002 181.196C121.656 182.935 117.341 184.755 113.002 186.632C112.82 186.746 112.616 186.822 112.404 186.857C112.192 186.892 111.974 186.884 111.765 186.834C111.556 186.784 111.358 186.693 111.184 186.567C111.01 186.44 110.863 186.28 110.752 186.095C108.972 184.024 107.096 182.033 105.251 180.042C104.012 178.671 102.496 177.577 100.803 176.835C99.1104 176.092 97.2792 175.718 95.4307 175.735C93.5823 175.753 91.7586 176.163 90.0802 176.937C88.4018 177.712 86.9069 178.834 85.6943 180.229C83.8662 182.261 82.095 184.332 80.1937 186.282C79.9382 186.503 79.6348 186.661 79.3077 186.744C78.9806 186.827 78.6386 186.833 78.3087 186.762C73.4825 184.885 68.6887 182.902 64.1875 181.074ZM63.5537 126.214C63.6933 134.549 67.1037 142.494 73.0492 148.336C78.9947 154.179 86.9987 157.449 95.3343 157.443C103.67 157.437 111.669 154.154 117.605 148.302C123.542 142.451 126.94 134.5 127.067 126.165C127.148 108.615 112.962 94.5592 95.1437 94.478C77.7725 94.3724 63.6187 108.591 63.5456 126.214H63.5537Z'
            fill='#735FD7'
          />
          <path
            d='M134.875 126.157C134.973 104.293 117.301 86.7754 95.0625 86.6617C73.4338 86.5479 55.7944 104.26 55.6969 126.214C55.575 147.94 73.1738 165.539 95.1194 165.718C100.333 165.752 105.503 164.754 110.329 162.78C115.155 160.807 119.542 157.897 123.238 154.219C126.934 150.542 129.865 146.168 131.863 141.352C133.86 136.536 134.884 131.371 134.875 126.157ZM63.5457 126.214C63.6188 108.591 77.7725 94.3723 95.1357 94.4698C112.954 94.5592 127.14 108.615 127.059 126.157C126.932 134.492 123.534 142.443 117.597 148.294C111.661 154.145 103.662 157.428 95.3262 157.435C86.9907 157.441 78.9867 154.171 73.0412 148.328C67.0957 142.486 63.6852 134.54 63.5457 126.206V126.214Z'
            fill='#402CA4'
          />
          <path
            d='M139.612 126.149C139.75 101.668 119.933 82.0623 95.0623 81.9323C70.8417 81.8023 51.0898 101.635 50.9842 126.222C50.838 150.548 70.5573 170.251 95.1273 170.454C100.963 170.487 106.748 169.365 112.149 167.153C117.549 164.94 122.458 161.681 126.593 157.562C130.728 153.444 134.008 148.548 136.242 143.156C138.476 137.765 139.621 131.985 139.612 126.149Z'
            stroke='#402CA4'
            strokeWidth='0.99'
            strokeMiterlimit='10'
          />
          <path
            d='M64.1875 181.074C64.1875 177.995 64.0412 175.151 64.1875 172.324C64.7075 163.386 58.5 157.146 49.5625 157.699C47.125 157.845 44.6225 157.942 42.1443 158.105C41.7524 158.193 41.3416 158.124 40.9998 157.913C40.6581 157.702 40.4127 157.365 40.3162 156.975C38.5287 152.566 36.6789 148.184 34.7668 143.829C34.6591 143.644 34.5889 143.44 34.5604 143.228C34.5319 143.015 34.5456 142.8 34.6007 142.593C34.6558 142.386 34.7512 142.192 34.8815 142.022C35.0118 141.852 35.1744 141.71 35.36 141.603C37.3668 139.856 39.3087 138.044 41.2831 136.232C42.6866 135.004 43.8093 133.488 44.575 131.787C45.3407 130.086 45.7314 128.24 45.7206 126.375C45.7099 124.51 45.2978 122.669 44.5125 120.977C43.7272 119.285 42.587 117.782 41.1693 116.57C39.1381 114.75 37.1068 112.987 35.1162 111.069C34.9013 110.811 34.7491 110.506 34.6716 110.179C34.5941 109.852 34.5933 109.512 34.6693 109.184C36.4027 104.699 38.2227 100.244 40.1293 95.8186C40.3001 95.5311 40.5362 95.2878 40.8185 95.1085C41.1009 94.9292 41.4215 94.819 41.7543 94.7867C44.1918 94.7867 46.5725 94.9167 49.0018 95.0711C58.1181 95.6805 64.3012 89.5299 63.7487 80.4461C63.5618 77.6024 63.4643 74.7586 63.3181 71.7767C68.1931 69.7292 73.125 67.6411 78.065 65.6586C78.3349 65.6118 78.612 65.6286 78.8743 65.7076C79.1367 65.7865 79.377 65.9256 79.5762 66.1136C81.5181 68.1124 83.3706 70.1761 85.2637 72.2642C86.4969 73.6652 88.0172 74.7841 89.7214 75.5451C91.4256 76.306 93.2736 76.6911 95.1399 76.6742C97.0062 76.6572 98.8469 76.2386 100.537 75.4468C102.227 74.655 103.727 73.5086 104.934 72.0855C106.632 70.2005 108.363 68.348 109.988 66.398C110.266 65.9439 110.711 65.6167 111.227 65.4861C111.743 65.3555 112.29 65.432 112.751 65.6992C116.943 67.4949 121.16 69.2499 125.401 70.8911C126.636 71.3542 126.847 72.0367 126.791 73.1742C126.62 76.018 126.409 78.8617 126.409 81.7217C126.404 83.5149 126.769 85.2897 127.483 86.9346C128.197 88.5796 129.244 90.059 130.557 91.28C131.87 92.5009 133.422 93.437 135.115 94.0293C136.807 94.6216 138.604 94.8573 140.392 94.7217L149.792 94.2017C151.881 99.1499 153.944 104.049 155.943 108.989C155.974 109.264 155.944 109.542 155.857 109.804C155.77 110.066 155.628 110.307 155.439 110.509C153.424 112.434 151.32 114.27 149.272 116.196C147.895 117.422 146.794 118.928 146.043 120.612C145.291 122.297 144.907 124.122 144.916 125.966C144.924 127.811 145.325 129.632 146.092 131.31C146.858 132.987 147.973 134.483 149.362 135.696C151.393 137.532 153.481 139.287 155.439 141.189C155.668 141.472 155.831 141.803 155.915 142.157C156 142.511 156.004 142.88 155.927 143.236C154.21 147.667 152.411 152.06 150.532 156.415C150.343 156.727 150.084 156.99 149.775 157.184C149.466 157.377 149.116 157.495 148.752 157.528C146.266 157.528 143.804 157.382 141.326 157.227C132.47 156.715 126.262 162.964 126.864 171.852C127.026 174.29 127.107 176.654 127.294 179.067C127.398 179.521 127.321 179.996 127.08 180.394C126.839 180.791 126.452 181.079 126.002 181.196C121.656 182.935 117.341 184.755 113.002 186.632C112.82 186.746 112.616 186.822 112.404 186.857C112.192 186.892 111.974 186.884 111.765 186.834C111.556 186.784 111.358 186.693 111.184 186.567C111.01 186.44 110.863 186.28 110.752 186.095C108.972 184.024 107.096 182.033 105.251 180.042C104.012 178.671 102.496 177.577 100.803 176.835C99.1104 176.092 97.2792 175.718 95.4307 175.735C93.5823 175.753 91.7586 176.163 90.0802 176.937C88.4018 177.712 86.9069 178.834 85.6943 180.229C83.8662 182.261 82.095 184.332 80.1937 186.282C79.9382 186.503 79.6348 186.661 79.3077 186.744C78.9806 186.827 78.6386 186.833 78.3087 186.762C73.4825 184.885 68.6887 182.902 64.1875 181.074ZM63.5537 126.214C63.6933 134.549 67.1037 142.494 73.0492 148.336C78.9947 154.179 86.9987 157.449 95.3343 157.443C103.67 157.437 111.669 154.154 117.605 148.302C123.542 142.451 126.94 134.5 127.067 126.165C127.148 108.615 112.962 94.5592 95.1437 94.478C77.7725 94.3724 63.6187 108.591 63.5456 126.214H63.5537Z'
            stroke='#5037CD'
            strokeWidth='3.94'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M71.3946 124.751L84.9471 132.575L95.664 126.327L95.7127 113.928L82.1602 106.104C81.9749 105.995 81.8212 105.839 81.7145 105.653C81.6077 105.466 81.5516 105.255 81.5516 105.04C81.5516 104.825 81.6077 104.613 81.7145 104.427C81.8212 104.24 81.9749 104.084 82.1602 103.975C86.55 101.329 91.6219 100.034 96.743 100.252C101.864 100.47 106.808 102.191 110.957 105.201C115.106 108.21 118.277 112.375 120.074 117.175C121.871 121.976 122.215 127.199 121.063 132.193L170.008 181.138C172.6 183.73 174.057 187.245 174.058 190.91C174.058 194.575 172.603 198.091 170.012 200.683C167.421 203.275 163.906 204.732 160.24 204.733C156.575 204.734 153.059 203.278 150.467 200.687L101.563 151.791C97.6869 152.692 93.6563 152.696 89.779 151.801C85.9017 150.906 82.2803 149.137 79.1914 146.628C76.1026 144.119 73.6282 140.938 71.9572 137.326C70.2862 133.715 69.4629 129.769 69.5502 125.791C69.5561 125.578 69.617 125.37 69.727 125.187C69.8371 125.005 69.9925 124.854 70.1782 124.749C70.3639 124.644 70.5735 124.59 70.7866 124.59C70.9998 124.59 71.2092 124.646 71.3946 124.751Z'
            fill='#57D08A'
          />
          <path
            d='M152.49 198.681L103.578 149.768C99.7923 150.647 95.8585 150.67 92.0634 149.835C88.2683 148.999 84.7076 147.327 81.6414 144.94C78.5751 142.552 76.0807 139.51 74.3403 136.036C72.5998 132.562 71.6572 128.742 71.5813 124.857L71.3944 124.751C71.2083 124.644 70.9972 124.587 70.7822 124.586C70.5672 124.585 70.3557 124.64 70.1686 124.746C69.9815 124.852 69.8252 125.005 69.7153 125.19C69.6054 125.374 69.5456 125.585 69.5419 125.8C69.4546 129.778 70.2779 133.724 71.9489 137.335C73.6199 140.946 76.0943 144.128 79.1831 146.637C82.272 149.145 85.8934 150.915 89.7707 151.809C93.648 152.704 97.6786 152.701 101.554 151.8L150.467 200.688C151.75 201.976 153.275 202.999 154.955 203.696C156.634 204.394 158.435 204.753 160.254 204.753C162.072 204.753 163.873 204.394 165.552 203.696C167.232 202.999 168.757 201.976 170.04 200.688C170.381 200.338 170.698 199.989 170.999 199.623C168.346 201.789 164.983 202.891 161.563 202.717C158.143 202.543 154.909 201.104 152.49 198.681Z'
            fill='#DCD7F5'
          />
          <path
            d='M153.262 197.908L104.349 148.996C100.564 149.877 96.6296 149.9 92.8338 149.066C89.0381 148.231 85.4768 146.559 82.4101 144.171C79.3435 141.783 76.8491 138.741 75.1091 135.266C73.369 131.79 72.4274 127.97 72.353 124.085L72.1661 123.979C71.98 123.872 71.7689 123.814 71.5539 123.813C71.3389 123.813 71.1274 123.868 70.9403 123.974C70.7532 124.079 70.5969 124.232 70.487 124.417C70.3771 124.602 70.3173 124.812 70.3136 125.027C70.2282 129.004 71.0525 132.948 72.7235 136.558C74.3945 140.168 76.8682 143.348 79.9556 145.856C83.043 148.364 86.6626 150.134 90.5382 151.03C94.4138 151.926 98.4429 151.925 102.318 151.027L151.239 199.94C152.522 201.228 154.047 202.251 155.727 202.948C157.406 203.646 159.207 204.005 161.025 204.005C162.844 204.005 164.644 203.646 166.324 202.948C168.003 202.251 169.528 201.228 170.812 199.94C171.153 199.598 171.47 199.241 171.771 198.875C169.115 201.037 165.75 202.136 162.33 201.957C158.91 201.778 155.678 200.335 153.262 197.908Z'
            fill='#DCD7F5'
          />
          <path
            d='M170.04 181.139L121.063 132.194C122.278 126.782 121.754 121.124 119.566 116.026C117.378 110.929 113.636 106.652 108.875 103.805C104.029 100.948 98.3872 99.7388 92.7959 100.36C96.4175 100.777 99.911 101.951 103.05 103.805C107.811 106.652 111.552 110.929 113.74 116.026C115.929 121.124 116.453 126.782 115.237 132.194L164.182 181.139C165.947 182.895 167.204 185.095 167.821 187.506C168.438 189.917 168.392 192.451 167.688 194.838C166.984 197.226 165.647 199.378 163.82 201.069C161.993 202.759 159.743 203.925 157.308 204.442C160.232 205.088 163.287 204.767 166.012 203.526C168.737 202.286 170.985 200.194 172.418 197.564C173.851 194.935 174.391 191.912 173.956 188.949C173.521 185.987 172.136 183.246 170.008 181.139H170.04Z'
            fill='#2C2B69'
          />
          <path
            d='M95.7206 151.791C94.7299 152.023 93.7259 152.194 92.7144 152.303C93.9335 152.439 95.1606 152.491 96.3869 152.457L95.7206 151.791Z'
            fill='#2C2B69'
          />
          <path
            d='M71.3946 124.751L84.9471 132.575L95.664 126.327L95.7127 113.928L82.1602 106.104C81.9749 105.995 81.8212 105.839 81.7145 105.653C81.6077 105.466 81.5516 105.255 81.5516 105.04C81.5516 104.825 81.6077 104.613 81.7145 104.427C81.8212 104.24 81.9749 104.084 82.1602 103.975C86.55 101.329 91.6219 100.034 96.743 100.252C101.864 100.47 106.808 102.191 110.957 105.201C115.106 108.21 118.277 112.375 120.074 117.175C121.871 121.976 122.215 127.199 121.063 132.193L170.008 181.138C172.6 183.73 174.057 187.245 174.058 190.91C174.058 194.575 172.603 198.091 170.012 200.683C167.421 203.275 163.906 204.732 160.24 204.733C156.575 204.734 153.059 203.278 150.467 200.687L101.563 151.791C97.6869 152.692 93.6563 152.696 89.779 151.801C85.9017 150.906 82.2803 149.137 79.1914 146.628C76.1026 144.119 73.6282 140.938 71.9572 137.326C70.2862 133.715 69.4629 129.769 69.5502 125.791C69.5561 125.578 69.617 125.37 69.727 125.187C69.8371 125.005 69.9925 124.854 70.1782 124.749C70.3639 124.644 70.5735 124.59 70.7866 124.59C70.9998 124.59 71.2092 124.646 71.3946 124.751Z'
            stroke='#5037CD'
            strokeWidth='3.94'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M162.095 185.566L126.624 150.095C124.578 148.049 121.259 148.049 119.213 150.095L119.207 150.101C117.16 152.148 117.16 155.466 119.207 157.512L154.678 192.984C156.725 195.03 160.043 195.03 162.09 192.984L162.095 192.978C164.142 190.931 164.142 187.613 162.095 185.566Z'
            fill='#DCD7F5'
          />
          <path
            d='M158.068 186.48L125.711 154.123C125.025 153.437 123.914 153.437 123.229 154.123C122.543 154.808 122.543 155.919 123.229 156.605L155.586 188.962C156.271 189.647 157.383 189.647 158.068 188.962C158.753 188.277 158.753 187.165 158.068 186.48Z'
            fill='#2C2B69'
          />
        </svg>
      )

    case 'account-info':
      return (
        <svg
          width='27'
          height='27'
          viewBox='0 0 27 27'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_166_24364)'>
            <path
              d='M26.347 9.34385C23.9628 2.07516 16.1817 -1.75134 8.96375 0.781246C2.95657 2.88198 -0.760365 8.96887 0.131667 15.2804C0.614681 18.7283 2.13203 21.531 4.64671 23.674C4.98173 23.9669 5.33139 24.2436 5.69446 24.5024C6.11933 24.8054 6.56291 25.0837 7.02234 25.3368C8.94789 26.3963 11.1601 27 13.5138 27C15.8674 27 18.0532 26.404 19.9702 25.3563C20.1239 25.2722 20.2755 25.1853 20.4256 25.0955C23.9356 22.996 26.4092 19.3458 26.8995 15.0923C27.1329 13.1955 26.9666 11.235 26.3474 9.34385H26.347ZM3.11635 11.9512C3.79208 6.80233 8.27867 2.96648 13.5162 2.9287C14.2858 3.04123 15.0742 3.08795 15.8345 3.2663C20.9594 4.42006 24.4226 9.12813 23.9347 14.3611C23.6737 17.2207 22.4406 19.5221 20.4252 21.3381V20.4727C20.2987 18.0494 18.4081 16.0942 16.0114 15.876H10.0924C7.7123 16.0958 5.83148 18.0259 5.6847 20.4232C3.60221 18.0714 2.6805 15.2532 3.11595 11.9508L3.11635 11.9512Z'
              fill='white'
            />
            <path
              d='M13.0518 15.1468C15.3787 15.1468 17.2632 13.2605 17.2632 10.9388C17.2632 8.61707 15.3819 6.73083 13.0551 6.73083C10.7282 6.73083 8.84375 8.61707 8.84375 10.9388C8.84375 13.2605 10.725 15.1468 13.0518 15.1468Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0_166_24364'>
              <rect width='27' height='27' fill='white' />
            </clipPath>
          </defs>
        </svg>
      )
    case 'account-verify':
      return (
        <svg
          width='20'
          height='22'
          viewBox='0 0 20 22'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M16.8744 1.74203C13.6451 -0.676397 10.0104 0.657745 8.35564 2.81217C7.01678 4.53289 6.78578 6.74389 7.49293 8.65317L0.760924 17.3086C0.680781 17.4123 0.638352 17.5396 0.647781 17.6716L0.902352 21.212C0.925924 21.509 1.2465 21.7447 1.53878 21.6835L5.93721 20.7547C6.19178 20.7029 6.38035 20.4389 6.35207 20.1796L6.13992 18.4777L7.84178 18.2656C8.11521 18.2279 8.33207 17.9497 8.29907 17.681L8.08692 15.9792L9.78878 15.767C9.9255 15.7529 10.0528 15.6775 10.1424 15.569L12.4995 12.533C14.5219 12.7452 16.6056 11.9815 17.9398 10.2655C19.9952 7.62075 19.5144 3.79746 16.8744 1.74203ZM15.8985 6.00375C15.2762 6.80517 14.1071 6.95132 13.3056 6.32903C12.5042 5.70675 12.3581 4.5376 12.9804 3.73617C13.6026 2.93475 14.7718 2.7886 15.5732 3.41089C16.3746 4.03317 16.5208 5.20232 15.8985 6.00375Z'
            fill='white'
          />
        </svg>
      )

    case 'PENDING':
      return (
        <svg
          width='30'
          height='30'
          viewBox='0 0 13 13'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.49707 0C2.91236 0 -0.00292322 2.91528 -0.00292969 6.5C-0.00293288 10.0847 2.91235 13 6.49707 13C10.0818 13 12.9971 10.0847 12.9971 6.5C12.9971 2.91528 10.0818 0 6.49707 0ZM6.49707 1.72995C9.12449 1.72995 11.2671 3.87257 11.2671 6.5C11.2671 9.12743 9.1245 11.2658 6.49707 11.2658C3.86964 11.2658 1.73124 9.12743 1.73125 6.5C1.73125 3.87257 3.86965 1.72995 6.49707 1.72995ZM6.49707 2.59746C4.33803 2.59746 2.59792 4.34096 2.59792 6.5C2.59791 8.65904 4.33802 10.3992 6.49707 10.3992C8.65612 10.3992 10.3996 8.65904 10.3996 6.5C10.3996 4.34096 8.65611 2.59746 6.49707 2.59746ZM6.49115 3.45736C6.54941 3.45633 6.60728 3.46706 6.6613 3.48891C6.71532 3.51075 6.76438 3.54327 6.80554 3.58452C6.8467 3.62576 6.87913 3.67488 6.90087 3.72894C6.92262 3.783 6.93324 3.84089 6.9321 3.89915V6.5C6.93118 6.61416 6.88525 6.72335 6.8043 6.80384L5.07096 8.53717C5.03211 8.58253 4.9843 8.61937 4.93053 8.64537C4.87677 8.67138 4.81821 8.68599 4.75853 8.68829C4.69885 8.69059 4.63934 8.68053 4.58373 8.65875C4.52813 8.63696 4.47762 8.60391 4.43539 8.56168C4.39316 8.51945 4.36011 8.46895 4.33832 8.41334C4.31654 8.35773 4.30648 8.29822 4.30878 8.23854C4.31108 8.17886 4.32569 8.1203 4.3517 8.06654C4.3777 8.01277 4.41454 7.96496 4.4599 7.92611L6.06543 6.31719V3.89915C6.06431 3.84218 6.07445 3.78554 6.09525 3.73248C6.11605 3.67943 6.14711 3.63099 6.18665 3.58996C6.2262 3.54892 6.27344 3.51608 6.32569 3.49333C6.37794 3.47058 6.43417 3.45835 6.49115 3.45736Z'
            fill='#605F9C'
          />
        </svg>
      )

    case 'APPROVED':
      return (
        <svg
          width='30'
          height='30'
          viewBox='0 0 13 13'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M6.5 0C2.90727 0 0 2.90727 0 6.5C0 10.0927 2.90727 13 6.5 13C10.0927 13 13 10.0927 13 6.5C13 2.90727 10.0927 0 6.5 0ZM9.88 5.06409L6.33455 8.75727C6.22227 8.87545 6.06273 8.93455 5.90909 8.93455C5.77909 8.93455 5.64318 8.89318 5.53682 8.80454L3.17318 6.88409C2.91909 6.67727 2.88364 6.305 3.08455 6.05091C3.29136 5.80273 3.66364 5.76136 3.91773 5.96818L5.86182 7.54591L9.02909 4.24273C9.25364 4.01227 9.63182 4.00636 9.86227 4.225C10.0986 4.44954 10.1045 4.82773 9.88 5.06409Z'
            fill='#2C96FF'
          />
        </svg>
      )

    case 'REJECTED':
      return (
        <svg
          width='30'
          height='30'
          viewBox='0 0 13 13'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_606_2)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M0 6.5C0 2.91576 2.91576 0 6.5 0C10.0842 0 13 2.91576 13 6.5C13 10.0842 10.0842 13 6.5 13C2.91576 13 0 10.0842 0 6.5ZM8.89366 8.89366C9.10542 8.68181 9.10542 8.33953 8.89366 8.12768L7.26588 6.5L8.89366 4.87232C9.10542 4.66047 9.10542 4.31819 8.89366 4.10634C8.68181 3.89458 8.33953 3.89458 8.12768 4.10634L6.5 5.73412L4.87232 4.10634C4.66047 3.89458 4.31819 3.89458 4.10634 4.10634C3.89458 4.31819 3.89458 4.66047 4.10634 4.87232L5.73412 6.5L4.10634 8.12768C3.89458 8.33953 3.89458 8.68181 4.10634 8.89366C4.21197 8.99929 4.35062 9.05235 4.48938 9.05235C4.62804 9.05235 4.76669 8.99929 4.87232 8.89366L6.5 7.26588L8.12768 8.89366C8.23331 8.99929 8.37196 9.05235 8.51062 9.05235C8.64938 9.05235 8.78803 8.99929 8.89366 8.89366Z'
              fill='#F44336'
            />
          </g>
          <defs>
            <clipPath id='clip0_606_2'>
              <rect width='13' height='13' fill='white' />
            </clipPath>
          </defs>
        </svg>
      )

    case 'space-rocket-launch':
      return (
        <svg
          width='23'
          height='23'
          viewBox='0 0 23 23'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.64516 10.2319L5.44847 11.3876C5.13258 12.1808 4.88056 12.9981 4.69457 13.8308L4.58841 14.3113L8.60738 18.3087L9.0907 18.2053C9.92876 18.0204 10.7504 17.7699 11.5483 17.4558L12.7109 20.2426C12.7342 20.2984 12.7843 20.3391 12.8438 20.3511C12.9038 20.3627 12.9655 20.3434 13.0078 20.3001L14.7646 18.5536C15.3442 17.9775 15.6515 17.1838 15.6105 16.37L15.5479 15.2482C18.8009 12.8604 22.0918 8.6729 22.9886 1.36487C23.0404 0.993361 22.9144 0.619272 22.6481 0.353721C22.3823 0.0877406 22.0068 -0.0392436 21.6327 0.0100915C14.2835 0.908418 10.069 4.18298 7.66704 7.40692L6.54071 7.34943C5.7238 7.30524 4.92587 7.6064 4.34415 8.17826L2.58734 9.92472C2.53771 9.96676 2.51441 10.0315 2.52649 10.0955C2.53857 10.159 2.58388 10.2113 2.64516 10.2323V10.2319ZM13.9162 5.97491C14.3245 5.57037 14.8777 5.34385 15.4538 5.34428C16.0304 5.34514 16.5827 5.57294 16.9901 5.97835C17.3975 6.38375 17.6262 6.9333 17.6262 7.50644C17.6262 8.07959 17.3975 8.62914 16.9901 9.03454C16.5827 9.43995 16.0304 9.66818 15.4538 9.66861C14.8773 9.66947 14.3245 9.44252 13.9162 9.03798C13.5067 8.63214 13.2767 8.08131 13.2767 7.50644C13.2767 6.93158 13.5067 6.38075 13.9162 5.97491ZM0.375673 18.1457C0.890505 17.0453 2.25591 14.8329 4.72823 16.6201C4.75455 16.6433 4.76922 16.6768 4.76922 16.7111C4.76922 16.7454 4.75412 16.7793 4.72823 16.8025C4.05717 17.328 3.67742 18.1397 3.7059 18.9886C3.70978 19.0907 3.79178 19.1723 3.89448 19.1761C4.74462 19.21 5.56067 18.8411 6.09363 18.1817C6.11693 18.1534 6.15232 18.1366 6.189 18.1366C6.22568 18.1366 6.26107 18.1534 6.28437 18.1817C6.62745 18.5875 7.61784 20.0723 6.57178 21.3529L6.42765 21.5236C6.13031 21.8737 5.31685 22.2889 4.80504 22.5554C3.81896 22.9535 1.89384 22.9633 1.52315 22.9835C1.35053 22.9929 0.786503 23.011 0.70192 22.9934C0.60698 22.9732 0.531029 22.9028 0.503841 22.8102C0.195287 21.805 -0.385571 19.8063 0.375673 18.1465V18.1457Z'
            fill='white'
          />
        </svg>
      )

    case 'limits':
      return (
        <svg
          width='21'
          height='28'
          viewBox='0 0 21 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M20.11 15.4612C19.7369 14.9182 19.182 14.859 18.6175 14.9083C17.9574 14.9774 17.4599 15.3921 17.0102 15.8561C16.3979 16.4782 15.9674 16.9521 15.2594 17.4655C15.1159 17.5642 14.982 17.6629 14.8002 17.5741C14.6088 17.4753 14.4175 17.268 14.4175 17.0705C14.4175 16.1326 14.4366 15.4119 14.4366 14.4838C14.4366 10.8999 14.4366 7.32582 14.4366 3.7419C14.4366 3.17914 14.2644 2.69536 13.8243 2.3498C13.3173 1.95488 12.7528 1.88577 12.1788 2.18196C11.7004 2.42879 11.423 2.81384 11.3369 3.30749C11.3177 3.43584 11.2986 3.56419 11.2986 3.71228C11.2986 6.38788 11.2986 8.0663 11.2986 10.7419C11.2986 10.8505 11.2986 10.9591 11.2986 11.0776C11.2986 11.1368 11.289 11.1862 11.2699 11.2257C11.222 11.354 11.1168 11.433 10.9637 11.4429C10.7533 11.4626 10.6289 11.3145 10.5906 11.1171C10.5715 10.9986 10.581 10.8703 10.581 10.7518C10.581 7.62202 10.581 5.48944 10.581 2.35968C10.581 1.65869 10.2462 1.15516 9.63389 0.878717C9.04072 0.622017 8.46669 0.710875 7.9692 1.16504C7.79699 1.323 7.68218 1.50072 7.59608 1.69818C7.49084 1.95488 7.46214 2.23133 7.46214 2.52752C7.4717 5.57829 7.46214 7.64176 7.46214 10.7024C7.46214 10.8406 7.46214 10.969 7.443 11.1072C7.43343 11.1862 7.4143 11.2553 7.37603 11.3145C7.31863 11.4034 7.21339 11.4528 7.08901 11.4528C6.8881 11.4429 6.76373 11.3145 6.75416 11.0973C6.7446 10.9887 6.7446 10.8801 6.7446 10.7617C6.7446 8.56983 6.7446 7.36532 6.7446 5.1735C6.7446 4.97604 6.73503 4.77858 6.70633 4.58111C6.58195 3.73203 5.74961 3.18901 4.95553 3.42597C4.42933 3.58394 4.07535 3.97886 3.97011 4.55149C3.94141 4.67984 3.93184 4.81807 3.93184 4.97604C3.93184 7.23697 3.93184 8.52046 3.93184 10.7814C3.93184 10.89 3.93184 10.9986 3.92227 11.1171C3.92227 11.1664 3.9127 11.2158 3.89357 11.2553C3.84573 11.3738 3.7405 11.4429 3.59699 11.4528C3.40564 11.4725 3.28127 11.354 3.23343 11.1664C3.20473 11.048 3.20473 10.9196 3.20473 10.8011C3.20473 9.19183 3.2143 8.55996 3.19517 6.95065C3.1856 6.24966 2.67854 5.73626 2.02797 5.70664C1.4348 5.67702 0.966008 6.02258 0.793798 6.5656C0.784231 6.63471 0.765097 6.72357 0.755529 6.81243C0.669425 6.95065 0.707693 7.09874 0.707693 7.24684C0.707693 12.2031 0.707693 17.1693 0.707693 22.1255C0.707693 22.6093 0.745962 23.0832 0.832067 23.5571C1.15735 25.3244 2.59243 27.6939 5.13731 27.5656C6.8307 27.4767 8.52409 27.5459 10.2175 27.5557C10.7341 27.5557 11.2412 27.4965 11.7195 27.299C12.504 26.9732 13.0685 26.0748 13.5851 25.4231C15.6325 22.8463 17.6895 20.2694 19.5933 17.5839C19.8421 17.2384 20.0717 16.8731 20.1961 16.4584C20.3013 16.103 20.3587 15.7673 20.11 15.4612ZM6.87854 24.1791C5.96009 24.1791 5.04163 24.1791 4.12318 24.1791C3.51088 24.1791 3.22387 23.8632 3.2143 23.2017C3.20473 21.8096 3.2143 20.4175 3.2143 19.0353C3.2143 17.6728 3.2143 16.3004 3.2143 14.938C3.2143 14.1777 3.47261 13.9112 4.19972 13.9112C5.78788 13.9112 7.37603 13.9112 8.95462 13.9112C9.59562 13.9112 9.8922 14.1876 9.8922 14.8392C9.90177 16.0734 9.8922 17.2976 9.8922 18.5317C9.8922 18.7391 9.8635 18.9365 9.64346 19.0155C9.37558 19.1241 9.17466 18.9267 9.17466 18.5614C9.17466 17.4062 9.15553 16.2511 9.18423 15.0959C9.1938 14.7405 9.08856 14.6418 8.74414 14.6516C7.25166 14.6714 5.75917 14.6714 4.27626 14.6516C3.99881 14.6516 3.9127 14.7207 3.9127 15.0169C3.92227 17.7024 3.92227 20.378 3.9127 23.0635C3.9127 23.3695 3.98924 23.4683 4.29539 23.4584C5.15644 23.4387 6.01749 23.4485 6.86897 23.4485C7.11772 23.4485 7.34733 23.4782 7.3569 23.7941C7.37603 24.1298 7.14642 24.1791 6.87854 24.1791ZM5.34778 15.56C5.34778 15.8364 5.17558 15.9648 4.91726 15.9944C4.64938 15.9549 4.48674 15.8167 4.48674 15.5205C4.48674 15.2341 4.63981 15.0959 4.90769 15.0959C5.19471 15.1058 5.34778 15.2638 5.34778 15.56ZM8.17011 19.6869C8.11271 20.0621 7.85439 20.3385 7.49084 20.4274C7.27079 20.4767 7.06031 20.457 6.8594 20.3385C6.802 20.3089 6.75416 20.2694 6.69676 20.2299C6.69676 20.2398 6.69676 20.2398 6.69676 20.2497C6.76373 20.4471 6.82113 20.6347 6.89767 20.8223C6.94551 20.9408 7.01248 21.0593 7.07945 21.1777H7.06031C7.06031 21.1777 7.05075 21.1777 7.05075 21.1679C6.76373 21.1185 6.47671 21.1086 6.1897 21.1382C6.11316 21.1481 6.03662 21.158 5.96008 21.1777H5.93138C5.93138 21.1679 5.93138 21.1679 5.94095 21.158C6.05576 20.9605 6.15143 20.7532 6.2184 20.5459C6.25667 20.4373 6.28537 20.3286 6.32364 20.2299C6.3045 20.2299 6.3045 20.2398 6.29494 20.2398C6.06532 20.4175 5.80701 20.4866 5.52956 20.4175C5.31908 20.3681 5.14687 20.2694 5.0225 20.0917C4.81202 19.7955 4.78332 19.4697 4.88856 19.134C4.94596 18.9267 5.07034 18.749 5.21384 18.591C5.38605 18.3935 5.58696 18.2257 5.78788 18.0578C5.99835 17.8801 6.20883 17.7024 6.38104 17.4951C6.46715 17.3963 6.56282 17.3963 6.65849 17.4951C6.75416 17.5938 6.84983 17.7024 6.94551 17.7913C7.13685 17.9591 7.32819 18.1171 7.51954 18.2849C7.71088 18.4528 7.88309 18.6305 8.01703 18.8378C8.15097 19.1143 8.21794 19.3907 8.17011 19.6869ZM12.6667 23.5078C12.6571 23.9521 12.4371 24.1989 12.0066 24.1989C11.0785 24.2088 10.1505 24.2088 9.2225 24.1989C8.78241 24.1989 8.56236 23.9619 8.5528 23.5078C8.54323 22.5501 8.54323 21.5924 8.5528 20.6347C8.5528 20.1509 8.77284 19.9337 9.23207 19.9337C10.1505 19.9337 11.069 19.9337 11.9874 19.9337C12.4466 19.9337 12.6667 20.1608 12.6763 20.6347C12.6858 21.1284 12.6763 21.622 12.6763 22.1058C12.6763 22.5698 12.6763 23.0339 12.6667 23.5078Z'
            fill='white'
          />
        </svg>
      )

    case 'refresh':
      return (
        <svg
          fill='#57d08a'
          height='23px'
          version='1.1'
          viewBox='0 0 28.539 29.123'
          width='23px'
          xmlSpace='preserve'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
        >
          <g>
            <path d='M7.63,7.938c3.215-3.215,8.132-3.674,11.847-1.402c-1.259,1.246-2.711,2.702-2.711,2.702   c-1.016,1.219,0.125,1.922,0.705,1.904l6.789-0.002c0.358,0,0.651,0.002,0.651,0.002s0.296,0,0.655,0h1.317   c0.359,0,0.651-0.293,0.652-0.653V1.154c0.042-0.854-0.896-1.682-1.864-0.729c0,0-1.602,1.561-2.708,2.657   C17.305-1.051,9.331-0.583,4.22,4.528C1.238,7.51-0.153,11.466,0.014,15.373h4.83C4.673,12.703,5.589,9.979,7.63,7.938z' />
            <path d='M23.695,13.75c0.171,2.67-0.745,5.394-2.786,7.435c-3.216,3.215-8.131,3.674-11.846,1.402   c1.258-1.246,2.71-2.702,2.71-2.702c1.016-1.219-0.125-1.922-0.705-1.903l-6.789,0.002c-0.358,0-0.651-0.002-0.651-0.002   s-0.296,0-0.655,0H1.654c-0.359,0-0.651,0.293-0.652,0.652v9.335c-0.041,0.853,0.896,1.681,1.865,0.728   c0,0,1.601-1.561,2.708-2.656c5.66,4.134,13.633,3.666,18.743-1.445c2.981-2.982,4.373-6.938,4.207-10.845H23.695z' />
          </g>
        </svg>
      )

    case 'bonus':
      return (
        <svg
          width='31'
          height='31'
          viewBox='0 0 31 31'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M8.05685 15.1807C8.3168 15.9809 7.58388 17.2958 8.06703 17.9662C8.5555 18.642 10.0364 18.3458 10.7122 18.8338C11.3774 19.317 11.5541 20.824 12.3543 21.084C13.1284 21.3333 14.147 20.2319 15.0048 20.2319C15.8626 20.2319 16.8861 21.339 17.6553 21.084C18.4556 20.824 18.6323 19.3223 19.2974 18.8338C19.9732 18.3453 21.4542 18.6363 21.9426 17.9662C22.4258 17.3011 21.6933 15.9809 21.9528 15.1807C22.2021 14.4066 23.5794 13.7777 23.5794 12.9199C23.5794 12.0621 22.2021 11.4337 21.9528 10.6591C21.6929 9.85886 22.4258 8.54402 21.9426 7.87353C21.4595 7.20349 19.9781 7.49444 19.3028 7.00597C18.6376 6.52282 18.4609 5.01577 17.6606 4.75582C16.8865 4.50649 15.868 5.60787 15.0101 5.60787C14.1523 5.60787 13.1289 4.50073 12.3596 4.75582C11.5594 5.01577 11.3827 6.5175 10.7175 7.00597C10.0417 7.49444 8.56082 7.20349 8.07235 7.87353C7.58919 8.5387 8.32168 9.85886 8.06216 10.6591C7.81283 11.4332 6.43555 12.0621 6.43555 12.9199C6.43555 13.7777 7.8022 14.4061 8.05685 15.1802V15.1807ZM15.0101 7.3235C18.0969 7.3235 20.607 9.83317 20.607 12.9203C20.607 16.0075 18.0973 18.5172 15.0101 18.5172C11.923 18.5172 9.41332 16.0075 9.41332 12.9203C9.41332 9.83317 11.9234 7.3235 15.0101 7.3235Z'
            fill='white'
          />
          <path
            d='M15.0106 17.4773C17.5202 17.4773 19.568 15.4353 19.568 12.9199C19.568 10.4044 17.526 8.36243 15.0106 8.36243C12.4951 8.36243 10.4531 10.4044 10.4531 12.9199C10.4531 15.4353 12.4956 17.4773 15.0106 17.4773ZM14.1271 11.6467L15.0106 9.85884L15.8941 11.6467L17.8635 11.9327L16.4397 13.3202L16.7776 15.2847L15.0159 14.3596L13.2542 15.2847L13.5921 13.3202L12.1683 11.9327L14.1271 11.6467Z'
            fill='white'
          />
          <path
            d='M27.7114 12.4009H25.6171C25.331 12.4009 25.0977 12.6347 25.0977 12.9204C25.0977 13.206 25.3315 13.4398 25.6171 13.4398H27.7114C27.9975 13.4398 28.2309 13.206 28.2309 12.9204C28.2309 12.6347 28.0024 12.4009 27.7114 12.4009Z'
            fill='white'
          />
          <path
            d='M4.91491 12.9204C4.91491 12.6343 4.68108 12.4009 4.39544 12.4009H2.30072C2.01464 12.4009 1.78125 12.6347 1.78125 12.9204C1.78125 13.206 2.01508 13.4398 2.30072 13.4398H4.39499C4.68595 13.4398 4.91446 13.206 4.91446 12.9204H4.91491Z'
            fill='white'
          />
          <path
            d='M24.6303 10.3943C24.6821 10.3943 24.7339 10.3842 24.7862 10.3682L26.6829 9.7708C26.9584 9.68267 27.109 9.39127 27.0208 9.12113C26.9327 8.84567 26.6466 8.6951 26.3712 8.78323L24.4744 9.38064C24.1989 9.46877 24.0484 9.76017 24.1365 10.0303C24.2038 10.254 24.4066 10.3943 24.6298 10.3943H24.6303Z'
            fill='white'
          />
          <path
            d='M5.23053 15.4668L3.33377 16.0642C3.05832 16.1523 2.90775 16.4437 2.99587 16.7139C3.06319 16.9375 3.27133 17.0774 3.48966 17.0774C3.54147 17.0774 3.59329 17.0673 3.64555 17.0513L5.5423 16.4539C5.81776 16.3658 5.96833 16.0744 5.8802 15.8042C5.7965 15.5341 5.50599 15.3835 5.23053 15.4668Z'
            fill='white'
          />
          <path
            d='M3.33984 9.77078L5.2366 10.3682C5.28842 10.3837 5.34023 10.3943 5.39249 10.3943C5.61082 10.3943 5.81852 10.2539 5.88627 10.0307C5.9744 9.75528 5.81896 9.46432 5.54837 9.38106L3.65162 8.78365C3.37616 8.69552 3.0852 8.85096 3.00194 9.12155C2.91337 9.39169 3.06394 9.68265 3.3394 9.77078H3.33984Z'
            fill='white'
          />
          <path
            d='M24.4684 16.4588L26.3652 17.0562C26.417 17.0717 26.4688 17.0823 26.5211 17.0823C26.7394 17.0823 26.9471 16.9419 27.0148 16.7187C27.103 16.4433 26.9475 16.1523 26.6769 16.069L24.7802 15.4716C24.5047 15.3835 24.2138 15.5389 24.1305 15.8095C24.0468 16.0797 24.1978 16.3706 24.468 16.4588H24.4684Z'
            fill='white'
          />
          <path
            d='M12.0339 22.0715C11.1664 21.7907 10.7815 20.9852 10.4698 20.3359C10.3661 20.1176 10.1943 19.754 10.0956 19.6708C10.0646 19.65 9.99194 19.6291 9.91355 19.6136L7.64258 23.9063L10.9268 22.8252L11.8829 26.1511L14.2992 21.583C14.289 21.5883 14.2784 21.5932 14.2682 21.5985C13.7797 21.8638 13.2235 22.1596 12.5999 22.1596C12.4077 22.1596 12.2151 22.1282 12.0335 22.0711L12.0339 22.0715Z'
            fill='white'
          />
          <path
            d='M19.9116 19.6757C19.8235 19.7537 19.6463 20.1173 19.5427 20.3356C19.2309 20.9853 18.8461 21.7908 17.9785 22.0711C17.7965 22.1283 17.6096 22.1593 17.4121 22.1593C16.7886 22.1593 16.2324 21.863 15.7439 21.5982C15.7337 21.5929 15.7231 21.588 15.7129 21.5827L18.1291 26.1507L19.0852 22.8249L22.3695 23.9059L20.0985 19.6133C20.0206 19.6341 19.9479 19.6549 19.9116 19.6757Z'
            fill='white'
          />
        </svg>
      )

    case 'deposit-funds':
      return (
        <svg
          width='33'
          height='33'
          viewBox='0 0 33 33'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M25.2121 12.672H7.78809C7.34967 12.672 6.99609 13.0256 6.99609 13.464V22.968C6.99609 23.4064 7.34967 23.76 7.78809 23.76H25.2121C25.6505 23.76 26.0041 23.4064 26.0041 22.968V13.464C26.0041 13.0256 25.6505 12.672 25.2121 12.672ZM22.1572 22.176H10.843C10.5554 21.0681 9.68795 20.2007 8.58009 19.9131V16.5236C9.68795 16.236 10.5554 15.3686 10.843 14.2607H22.1572C22.4448 15.3686 23.3122 16.236 24.4201 16.5236V19.9179C23.3122 20.2007 22.4448 21.0681 22.1572 22.176Z'
            fill='white'
          />
          <path
            d='M18.875 18.216C18.875 19.5265 17.8096 20.592 16.499 20.592C15.1885 20.592 14.123 19.5265 14.123 18.216C14.123 16.9054 15.1885 15.84 16.499 15.84C17.8096 15.84 18.875 16.9054 18.875 18.216Z'
            fill='white'
          />
          <path
            d='M20.2295 7.92469L17.0615 11.0927C16.7503 11.4038 16.2506 11.4038 15.9395 11.0927L12.7715 7.92469C12.5452 7.69841 12.4792 7.35898 12.6018 7.06198C12.7243 6.76498 13.0119 6.57169 13.3325 6.57169H14.9165V4.19569C14.9165 3.31884 15.6236 2.61169 16.5005 2.61169C17.3773 2.61169 18.0845 3.31884 18.0845 4.19569V6.57169H19.6685C19.9891 6.57169 20.2766 6.76498 20.3992 7.06198C20.5218 7.35898 20.4558 7.69841 20.2295 7.92469Z'
            fill='white'
          />
          <path
            d='M29.3191 19.8661H27.4004L27.391 19.8943C27.2684 20.3422 27.2684 20.8136 27.391 21.2615L27.4004 21.2898H28.6025V25.1413H4.35226V21.2615H5.64869C5.75711 20.7995 5.75711 20.3186 5.6534 19.8566L5.64869 19.8378H3.63569C3.23969 19.8378 2.92383 20.1583 2.92383 20.5496V25.8013C2.92383 26.1973 3.2444 26.5132 3.63569 26.5132H29.3144C29.7104 26.5132 30.0263 26.1926 30.0263 25.8013V20.5779C30.031 20.1772 29.7151 19.8661 29.3191 19.8661Z'
            fill='white'
          />
        </svg>
      )

    case 'withdraw-funds':
      return (
        <svg
          width='27'
          height='24'
          viewBox='0 0 27 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_166_24230)'>
            <path
              d='M4.79936 13.8984L22.1545 13.8984C22.5907 13.8984 22.9434 13.5425 22.9434 13.1032L22.9434 3.56018C22.9434 3.1209 22.5902 2.76493 22.1545 2.76493L4.79936 2.76493C4.36313 2.76493 4.01049 3.1209 4.01049 3.56018L4.01049 13.1032C4.01049 13.5425 4.3636 13.8984 4.79936 13.8984ZM7.84355 4.35543L19.1108 4.35543C19.3967 5.46926 20.2607 6.34024 21.3661 6.629L21.3661 10.0348C20.2612 10.3236 19.3972 11.1941 19.1108 12.3084L7.84355 12.3084C7.55711 11.1946 6.69358 10.3236 5.58823 10.0348L5.58823 6.62899C6.69358 6.34072 7.55711 5.4702 7.84402 4.3559L7.84355 4.35543Z'
              fill='white'
            />
            <path
              d='M11.1105 8.33166C11.1105 7.01618 12.1722 5.94591 13.4771 5.94591C14.7821 5.94591 15.8438 7.01618 15.8438 8.33166C15.8438 9.64713 14.7821 10.7174 13.4771 10.7174C12.1722 10.7174 11.1105 9.64713 11.1105 8.33166Z'
              fill='white'
            />
            <path
              d='M9.76258 20.5861C9.53719 20.3584 9.4691 20.0171 9.59119 19.7194C9.7128 19.4221 10.0011 19.2285 10.32 19.2285L11.8977 19.2285L11.8977 16.8427C11.8977 15.9642 12.6039 15.2522 13.4754 15.2522C14.3469 15.2522 15.0532 15.9642 15.0532 16.8427L15.0532 19.2285L16.6309 19.2285C16.9497 19.2285 17.2381 19.4221 17.3597 19.7194C17.4822 20.0171 17.4141 20.3589 17.1888 20.5861L14.0333 23.7671C13.7257 24.0776 13.2256 24.0776 12.9181 23.7671L9.76258 20.5861Z'
              fill='white'
            />
            <path
              d='M0.710451 6.67585L2.6197 6.67585L2.62769 6.64603C2.7479 6.19633 2.7479 5.7225 2.62769 5.2728L2.6197 5.24345L1.4209 5.24345L1.4209 1.3756L25.5791 1.3756L25.5791 5.27233L24.2864 5.27233C24.1798 5.7367 24.1784 6.21906 24.2817 6.6839L24.2864 6.7052L26.2895 6.7052C26.6821 6.7052 27 6.38473 27 5.989L27 0.717153C27 0.321421 26.6821 0.000953647 26.2895 0.000953612L0.710452 0.000951376C0.317895 0.000951342 -1.34926e-06 0.321418 -1.38386e-06 0.71715L-1.84221e-06 5.96012C-1.87726e-06 6.36106 0.312729 6.67632 0.710451 6.67632L0.710451 6.67585Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0_166_24230'>
              <rect
                width='27'
                height='24'
                fill='white'
                transform='translate(27 24) rotate(-180)'
              />
            </clipPath>
          </defs>
        </svg>
      )

    case 'transaction-history':
      return (
        <svg
          width='27'
          height='24'
          viewBox='0 0 27 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_166_24218)'>
            <path
              d='M14.0055 6.31543C10.9652 6.31543 8.49219 8.78401 8.49219 11.8182V13.6202C8.49219 16.6544 10.9657 19.1225 14.0055 19.1225C17.0454 19.1225 19.5194 16.6539 19.5194 13.6202V11.8182C19.5194 8.78401 17.0459 6.31543 14.0055 6.31543ZM12.6372 7.06085C13.5172 6.81288 14.465 6.81288 15.3455 7.06085V7.92799C14.4539 7.71386 13.5288 7.71386 12.6372 7.92799V7.06085ZM11.7344 7.40983V8.2209C10.7977 8.61483 9.98552 9.2345 9.36461 10.034C9.80487 8.89663 10.651 7.97294 11.7344 7.40983ZM13.9985 18.5816C13.9985 18.5816 13.9959 18.5816 13.9949 18.5816C13.9939 18.5816 13.9924 18.5816 13.9914 18.5816C11.2491 18.5816 9.02606 16.363 9.02606 13.6262C9.02606 10.8895 11.2491 8.67089 13.9914 8.67089C13.9914 8.67089 13.9939 8.67089 13.9949 8.67089C13.9959 8.67089 13.9974 8.67089 13.9985 8.67089C16.7407 8.67089 18.9638 10.8895 18.9638 13.6262C18.9638 16.363 16.7407 18.5816 13.9985 18.5816ZM16.2483 8.2209V7.40983C17.3318 7.96183 18.1779 8.89663 18.6181 10.034C17.9977 9.2345 17.185 8.61483 16.2483 8.2209Z'
              fill='white'
            />
            <path
              d='M13.9892 17.815C16.3089 17.815 18.1894 15.9383 18.1894 13.6233C18.1894 11.3082 16.3089 9.43152 13.9892 9.43152C11.6695 9.43152 9.78906 11.3082 9.78906 13.6233C9.78906 15.9383 11.6695 17.815 13.9892 17.815Z'
              fill='white'
            />
            <path
              d='M21.6609 14.2115C21.6609 18.1275 18.4799 21.3021 14.556 21.3021H6.19716C5.765 21.3021 5.41127 21.6551 5.41127 22.0864C5.41127 22.3531 5.11372 22.5122 4.89156 22.3642L1.67717 20.2284C1.47829 20.0961 1.47829 19.8047 1.67717 19.6724L4.89156 17.5366C5.11372 17.3886 5.41127 17.5477 5.41127 17.8144C5.41127 18.2457 5.765 18.5987 6.19716 18.5987H8.29623C8.45563 18.5987 8.59328 18.4861 8.62415 18.33L8.64186 18.2411C8.64996 18.2012 8.65046 18.1598 8.64338 18.1194L8.61858 17.975C8.59075 17.8149 8.45159 17.6977 8.28864 17.6977H6.64804C6.46334 17.6977 6.31355 17.5482 6.31355 17.3639V16.3463C6.31355 16.0983 6.11062 15.8958 5.86216 15.8958C5.77208 15.8958 5.6815 15.9185 5.61369 15.9746L0.198001 19.5795C0.00114976 19.7103 -0.0580574 19.9789 0.0618751 20.1799C0.0694658 20.1926 0.0780685 20.2047 0.0871773 20.2158C0.119058 20.2547 0.15853 20.2931 0.197495 20.3224L5.61419 23.9262C5.81712 24.0616 6.09949 24.005 6.23461 23.8025C6.27964 23.7237 6.31355 23.6449 6.31355 23.5545V22.5369C6.31355 22.3526 6.46334 22.2031 6.64804 22.2031H14.555C18.9778 22.2031 22.5626 18.6249 22.5626 14.2115V12.1762C22.5626 11.9919 22.4128 11.8424 22.2281 11.8424H21.9943C21.8096 11.8424 21.6599 11.9919 21.6599 12.1762V14.2115H21.6609Z'
              fill='white'
            />
            <path
              d='M5.33833 9.78849C5.33833 5.87249 8.51933 2.69788 12.4432 2.69788H20.8015C21.2337 2.69788 21.5874 2.34486 21.5874 1.91357C21.5874 1.64691 21.885 1.48783 22.1071 1.6358L25.3215 3.77157C25.5204 3.90389 25.5204 4.19529 25.3215 4.32761L22.1071 6.46338C21.885 6.61135 21.5874 6.45227 21.5874 6.18561C21.5874 5.75432 21.2337 5.4013 20.8015 5.4013H18.7025C18.5431 5.4013 18.4054 5.51392 18.3745 5.66998L18.3568 5.75886C18.3487 5.79876 18.3482 5.84017 18.3553 5.88057L18.3801 6.02501C18.4079 6.18511 18.5471 6.30227 18.71 6.30227H20.3506C20.5354 6.30227 20.6851 6.45176 20.6851 6.6361V7.65373C20.6851 7.9017 20.8881 8.10422 21.1365 8.10422C21.2266 8.10422 21.3172 8.08149 21.385 8.02543L26.8017 4.42154C26.9986 4.29074 27.0578 4.02207 26.9378 3.82106C26.9302 3.80844 26.9216 3.79632 26.9125 3.78521C26.8806 3.74632 26.8412 3.70794 26.8022 3.67865L21.3845 0.0737467C21.1816 -0.0616011 20.8992 -0.00503786 20.7641 0.197479C20.719 0.276263 20.6851 0.355048 20.6851 0.445448V1.46258C20.6851 1.64691 20.5354 1.7964 20.3506 1.7964H12.4432C8.02037 1.7964 4.43555 5.37453 4.43555 9.78798V11.8233C4.43555 12.0076 4.58534 12.1571 4.77004 12.1571H5.00383C5.18854 12.1571 5.33833 12.0076 5.33833 11.8233V9.78798V9.78849Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0_166_24218'>
              <rect width='27' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      )

    case 'bet-history':
      return (
        <svg
          className='style-stroke'
          width='21'
          height='21'
          viewBox='0 0 21 21'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10 7V11L12 13'
            stroke='#DCD7F5'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.93254 4.26791C5.56501 2.77627 7.6895 1.93783 9.90068 1.91257C12.1119 1.88732 14.255 2.67701 15.9211 4.13098C17.5872 5.58495 18.6597 7.60142 18.934 9.79568C19.2083 11.9899 18.6651 14.2084 17.4082 16.0277C16.1512 17.8471 14.2684 19.14 12.1191 19.6598C9.96972 20.1796 7.70421 19.8899 5.7548 18.846C3.80539 17.8021 2.30853 16.077 1.5498 13.9999M1.0498 18.9999V13.9999H6.0498'
            stroke='#DCD7F5'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )

    case 'trash':
      return (
        <svg
          fill='#ff4141'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 32 32'
          width='32px'
          height='32px'
        >
          <path d='M 15 4 C 14.476563 4 13.941406 4.183594 13.5625 4.5625 C 13.183594 4.941406 13 5.476563 13 6 L 13 7 L 7 7 L 7 9 L 8 9 L 8 25 C 8 26.644531 9.355469 28 11 28 L 23 28 C 24.644531 28 26 26.644531 26 25 L 26 9 L 27 9 L 27 7 L 21 7 L 21 6 C 21 5.476563 20.816406 4.941406 20.4375 4.5625 C 20.058594 4.183594 19.523438 4 19 4 Z M 15 6 L 19 6 L 19 7 L 15 7 Z M 10 9 L 24 9 L 24 25 C 24 25.554688 23.554688 26 23 26 L 11 26 C 10.445313 26 10 25.554688 10 25 Z M 12 12 L 12 23 L 14 23 L 14 12 Z M 16 12 L 16 23 L 18 23 L 18 12 Z M 20 12 L 20 23 L 22 23 L 22 12 Z' />
        </svg>
      )

    case 'logout':
      return (
        <svg
          className='style-stroke'
          width='14'
          height='16'
          viewBox='0 0 14 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11.4705 4.23035C12.2432 5.09334 12.7494 6.16152 12.9282 7.3059C13.1069 8.45029 12.9504 9.62193 12.4777 10.6794C12.005 11.7368 11.2362 12.6348 10.2642 13.2649C9.29215 13.895 8.15846 14.2303 7 14.2303C5.84154 14.2303 4.70784 13.895 3.73582 13.2649C2.76379 12.6348 1.995 11.7368 1.52228 10.6794C1.04955 9.62193 0.893112 8.45029 1.07184 7.3059C1.25058 6.16152 1.75684 5.09334 2.5295 4.23035'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.00195 1V7.46063'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )

    case 'favorite':
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill={fill || 'none'}
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 20L4.99998 13C4.60601 12.5732 4.29997 12.073 4.09932 11.5279C3.89867 10.9828 3.80735 10.4036 3.83056 9.8232C3.87744 8.6511 4.38802 7.54563 5.24998 6.74998C6.11193 5.95433 7.25465 5.53368 8.42675 5.58056C9.59886 5.62745 10.7043 6.13803 11.5 6.99998C11.648 7.09887 11.822 7.15165 12 7.15165C12.178 7.15165 12.352 7.09887 12.5 6.99998C13.2956 6.13803 14.4011 5.62745 15.5732 5.58056C16.7453 5.53368 17.888 5.95433 18.75 6.74998C19.6119 7.54563 20.1225 8.6511 20.1694 9.8232C20.2163 10.9953 19.7956 12.138 19 13L12 20Z'
            stroke={color || '#ffffff'}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )

    case 'email-alert':
      return (
        <svg
          width='72'
          height='72'
          viewBox='0 0 72 72'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='72' height='72' rx='36' fill='#FCA0A4' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M36 28C31.5817 28 28 31.5817 28 36C28 40.4183 31.5817 44 36 44C40.4183 44 44 40.4183 44 36C44 31.5817 40.4183 28 36 28ZM26 36C26 30.4772 30.4772 26 36 26C41.5228 26 46 30.4772 46 36C46 41.5228 41.5228 46 36 46C30.4772 46 26 41.5228 26 36ZM36 31C36.5523 31 37 31.4477 37 32V36C37 36.5523 36.5523 37 36 37C35.4477 37 35 36.5523 35 36V32C35 31.4477 35.4477 31 36 31ZM36 39C35.4477 39 35 39.4477 35 40C35 40.5523 35.4477 41 36 41H36.01C36.5623 41 37.01 40.5523 37.01 40C37.01 39.4477 36.5623 39 36.01 39H36Z'
            fill='#9A1016'
          />
        </svg>
      )

    case 'email-resend':
      return (
        <svg
          width='72'
          height='72'
          viewBox='0 0 72 72'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='72' height='72' rx='36' fill='#57D08A' />
          <g
            xmlns='http://www.w3.org/2000/svg'
            transform='translate(22.000000,45.000000) scale(0.100000,-0.100000)'
          >
            <path
              stroke='white'
              fill='white'
              strokeWidth='2'
              d='M40 165 l-44 -45 44 -45 c50 -51 70 -57 70 -20 0 28 13 31 72 15 21 -6 42 -18 47 -28 9 -15 10 -15 11 4 0 37 -43 88 -88 104 -33 11 -42 19 -42 37 0 35 -21 28 -70 -22z m94 -19 c30 -6 95 -60 85 -71 -3 -2 -21 0 -40 5 -57 17 -77 13 -81 -14 -3 -24 -4 -23 -48 15 l-45 39 45 39 c43 37 45 38 48 16 2 -17 12 -25 36 -29z'
            />
          </g>
        </svg>
      )

    case 'profile-upload':
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='24' height='24' rx='12' fill='#57d08a' />
          <path
            d='M7.333,8.667H8A1.333,1.333,0,0,0,9.333,7.333.667.667,0,0,1,10,6.667h4a.667.667,0,0,1,.667.667A1.333,1.333,0,0,0,16,8.667h.667A1.333,1.333,0,0,1,18,10v6a1.333,1.333,0,0,1-1.333,1.333H7.333A1.333,1.333,0,0,1,6,16V10A1.333,1.333,0,0,1,7.333,8.667'
            fill='none'
            stroke='rgba(0,0,0,0.5)'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
          />
          <path
            d='M12,14.667a2,2,0,1,0-2-2A2,2,0,0,0,12,14.667Z'
            fill='none'
            stroke='rgba(0,0,0,0.5)'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
          />
        </svg>
      )

    case 'upload-image':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-2 -2)'>
            <path
              d='M21,15v4a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V15'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
            <path
              d='M17,8,12,3,7,8'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
            <path
              d='M12,3V15'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
            />
          </g>
        </svg>
      )

    case 'remove-image':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-2.045 -2.045)'>
            <path
              d='M12,21a9,9,0,1,0-9-9A9,9,0,0,0,12,21Z'
              fill='none'
              stroke='#fff'
              strokeMiterlimit='10'
              strokeWidth='1.91'
            />
            <path
              d='M7.089,12h9.823'
              fill='none'
              stroke='#fff'
              strokeMiterlimit='10'
              strokeWidth='1.91'
            />
          </g>
        </svg>
      )

    case 'forgot-password-lock':
      return (
        <svg
          width='72'
          height='72'
          viewBox='0 0 72 72'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='72' height='72' rx='36' fill='#57d08a' />
          <path
            d='M41,33V31a5,5,0,0,0-10,0v2a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H41a3,3,0,0,0,3-3V36a3,3,0,0,0-3-3Zm-8-2a3,3,0,0,1,6,0v2H33Zm9,12a1,1,0,0,1-1,1H31a1,1,0,0,1-1-1V36a1,1,0,0,1,1-1H41a1,1,0,0,1,1,1Z'
            fill='#fff'
          />
        </svg>
      )

    case 'eye-password-invisible':
      return (
        <svg
          width='17.002'
          height='17'
          viewBox='0 0 17.002 17'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-0.499 -0.5)'>
            <path
              d='M7.8,4.683A6.145,6.145,0,0,1,9,4.545c3.34,0,5.618,3.245,6.352,4.455a11.691,11.691,0,0,1-1.091,1.532,1,1,0,0,0,1.533,1.286,13.732,13.732,0,0,0,1.589-2.347,1,1,0,0,0,.013-.919C17.272,8.307,14.33,2.545,9,2.545a7.351,7.351,0,0,0-1.662.19A1,1,0,0,0,7.8,4.683Z'
              fill='#605f9c'
            />
            <path
              d='M17.207,15.793,8.258,6.844l-2.6-2.6L2.207.793A1,1,0,0,0,.793,2.207L3.477,4.891A13.478,13.478,0,0,0,.618,8.527a1.006,1.006,0,0,0-.014.92c.123.245,3.065,6.008,8.412,6.008a7.925,7.925,0,0,0,3.894-1.131l2.883,2.883a1,1,0,0,0,1.414-1.414ZM8.632,10.048a.778.778,0,0,1-.076-.028,1.033,1.033,0,0,1-.345-.226,1.05,1.05,0,0,1-.233-.352c-.008-.025-.019-.05-.026-.075ZM9,13.455c-3.34,0-5.617-3.243-6.352-4.455A11.459,11.459,0,0,1,4.883,6.3L6.24,7.656c-.026.051-.052.1-.074.155A3.031,3.031,0,0,0,5.9,9a2.992,2.992,0,0,0,.22,1.191A3.1,3.1,0,0,0,6.8,11.207a3.012,3.012,0,0,0,1.01.666A3.26,3.26,0,0,0,9,12.1a3,3,0,0,0,1.189-.263c.053-.022.1-.049.154-.074l1.106,1.105A5.871,5.871,0,0,1,9,13.455Z'
              fill='#605f9c'
            />
          </g>
        </svg>
      )

    case 'eye-password-visible':
      return (
        <svg
          width='16.993'
          height='12.91'
          viewBox='0 0 16.993 12.91'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-0.503 -0.545)'>
            <path
              d='M16.661,8.663a12.121,12.121,0,0,0,.733-1.216,1.007,1.007,0,0,0,.053-.231A.985.985,0,0,0,17.5,7a.968.968,0,0,0-.052-.227.964.964,0,0,0-.051-.22c-.109-.217-2.441-4.767-6.684-5.794-.019,0-.031-.019-.05-.023C10.5.7,10.346.68,10.19.654,10.1.638,10.01.618,9.915.606a7.576,7.576,0,0,0-.9-.06H8.987a7.593,7.593,0,0,0-.9.06c-.092.012-.179.032-.27.047C7.656.679,7.5.7,7.339.735a.452.452,0,0,0-.05.023C3.161,1.758.85,6.078.628,6.511l-.01.016s0,0,0,0a.2.2,0,0,1-.011.021.955.955,0,0,0-.042.185A1.024,1.024,0,0,0,.5,7a.929.929,0,0,0,.044.193.959.959,0,0,0,.058.253,12.422,12.422,0,0,0,.741,1.227.213.213,0,0,0,.016.025c1.183,1.741,3.734,4.673,7.512,4.747.037,0,.073.009.109.01h.033c.037,0,.073-.008.11-.01A9.115,9.115,0,0,0,15.79,9.819h0l.008-.01c.325-.393.6-.765.829-1.1ZM11.317,10.92c-.06.027-.121.051-.182.076-.1.043-.2.086-.3.123A5.788,5.788,0,0,1,9,11.455a5.8,5.8,0,0,1-1.835-.336c-.1-.035-.189-.076-.282-.115-.068-.028-.136-.055-.2-.086a8.95,8.95,0,0,1-3-2.459c-.161-.195-.315-.4-.464-.6-.044-.06-.082-.115-.122-.173-.156-.223-.307-.45-.447-.684,0-.005.008-.012.011-.018a11.535,11.535,0,0,1,.964-1.366c.023-.03.047-.059.071-.088A11.39,11.39,0,0,1,4.883,4.3l-.005-.006A6.672,6.672,0,0,1,8.146,2.625a7.5,7.5,0,0,1,.833-.079h.042a7.4,7.4,0,0,1,.843.08,6.68,6.68,0,0,1,3.258,1.667l-.006.006A11.326,11.326,0,0,1,14.31,5.535l.058.071a11.736,11.736,0,0,1,.977,1.382A.045.045,0,0,0,15.351,7c-.137.229-.286.451-.438.671-.049.068-.1.137-.148.209q-.207.284-.43.556A8.992,8.992,0,0,1,11.317,10.92Z'
              fill='#605f9c'
            />
            <path
              d='M9,3.875A3.125,3.125,0,1,0,12.125,7,3.128,3.128,0,0,0,9,3.875Zm0,4.25A1.125,1.125,0,1,1,10.125,7,1.127,1.127,0,0,1,9,8.125Z'
              fill='#605f9c'
            />
          </g>
        </svg>
      )

    case 'cross':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='32'
          height='32'
          fill='currentColor'
          className='bi bi-x'
          viewBox='0 0 16 16'
        >
          <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
        </svg>
      )

    case 'RE-REQUESTED':
      return (
        <svg
          id='Layer_1'
          width='30'
          height='30'
          color='#fff'
          data-name='Layer 1'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 115.08 122.88'
        >
          <path
            fill='#605f9c'
            d='M72,117.19a3.68,3.68,0,0,1-.58,0H7.52A7.53,7.53,0,0,1,2.22,115h0A7.5,7.5,0,0,1,0,109.72V7.52A7.5,7.5,0,0,1,2.21,2.21L2.44,2A7.51,7.51,0,0,1,7.52,0h85.1a7.5,7.5,0,0,1,5.31,2.21l.22.24a7.49,7.49,0,0,1,2,5.07V72.28A26.66,26.66,0,1,1,72,117.19Zm14.54-9,2-10.19,2,3.06c4.38-1.76,6.84-4.66,7.21-9.12,3.59,6.29,1.41,11.93-3.15,15.23l2.08,3.12-10.18-2.1ZM89.76,84.9l-2,10.19-2-3.06c-4.38,1.75-6.84,4.65-7.2,9.11-3.6-6.28-1.42-11.92,3.14-15.22l-2.07-3.13L89.76,84.9Zm3.92-14.81V7.52a1,1,0,0,0-.23-.65l-.09-.09a1.06,1.06,0,0,0-.74-.31H7.52a1,1,0,0,0-.66.23l-.08.08a1.06,1.06,0,0,0-.31.74v102.2a1.06,1.06,0,0,0,.31.74h0a1.08,1.08,0,0,0,.75.31H66.08a26.67,26.67,0,0,1,27.6-40.69Zm9.82,11.06a21.33,21.33,0,1,0,6.24,15.07,21.26,21.26,0,0,0-6.24-15.07ZM21,74.69h9.09a1.19,1.19,0,0,1,1.19,1.19V85a1.19,1.19,0,0,1-1.19,1.19H21A1.2,1.2,0,0,1,19.77,85V75.88A1.19,1.19,0,0,1,21,74.69ZM43.09,84a3.68,3.68,0,0,1,0-7.24h9.65a3.68,3.68,0,0,1,0,7.24ZM21,22.32h9.09a1.19,1.19,0,0,1,1.19,1.19V32.6a1.19,1.19,0,0,1-1.19,1.19H21a1.19,1.19,0,0,1-1.19-1.19V23.51A1.2,1.2,0,0,1,21,22.32Zm22.13,9.36a3.37,3.37,0,0,1-3-3.62,3.37,3.37,0,0,1,3-3.62H78.88a3.37,3.37,0,0,1,3,3.62,3.37,3.37,0,0,1-3,3.62ZM18.49,54.53a2,2,0,0,1,.38-2.83,2.25,2.25,0,0,1,3-.09L24,53.79l5.29-5.43a2,2,0,0,1,2.84.31,2.26,2.26,0,0,1,.18,3l-7,7.2a2,2,0,0,1-2.84-.3l-.16-.2a1.85,1.85,0,0,1-.32-.25l-3.49-3.61Zm24.6,2.71a3.67,3.67,0,0,1,0-7.23H78.88a3.67,3.67,0,0,1,0,7.23Z'
          />
        </svg>
      )

    case 'search-icon':
      return (
        <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path fill={fill} fillRule='evenodd' clipRule='evenodd' d='M0 6.56552C0 2.95172 2.95172 0 6.56552 0C10.1759 0 13.131 2.95172 13.131 6.56207C13.131 7.95172 12.6931 9.24483 11.9483 10.3103L16.6552 15.0207C17.1069 15.4724 17.1069 16.2034 16.6552 16.6552C16.2034 17.1069 15.4655 17.1069 15.0138 16.6552L10.3138 11.9552C9.24828 12.7 7.95517 13.131 6.56552 13.131C2.95172 13.131 0 10.1793 0 6.56552ZM10.8138 6.56552C10.8138 4.2069 8.92414 2.31724 6.56552 2.31724C4.20345 2.31724 2.31724 4.2069 2.31724 6.56552C2.31724 8.92414 4.2069 10.8138 6.56552 10.8138C8.92414 10.8138 10.8138 8.92414 10.8138 6.56552Z' />
        </svg>
      )

    case 'chart-icon':
      return (
        <svg width='26' height='28' viewBox='0 0 26 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M3.25 3.81836C3.25 2.88496 2.52383 2.13086 1.625 2.13086C0.726172 2.13086 0 2.88496 0 3.81836V21.5371C0 23.868 1.81797 25.7559 4.0625 25.7559H24.375C25.2738 25.7559 26 25.0018 26 24.0684C26 23.135 25.2738 22.3809 24.375 22.3809H4.0625C3.61562 22.3809 3.25 22.0012 3.25 21.5371V3.81836ZM23.8977 8.38516C24.5324 7.72598 24.5324 6.65547 23.8977 5.99629C23.2629 5.33711 22.232 5.33711 21.5973 5.99629L16.25 11.5545L13.3352 8.52754C12.7004 7.86836 11.6695 7.86836 11.0348 8.52754L5.34727 14.4338C4.7125 15.093 4.7125 16.1635 5.34727 16.8227C5.98203 17.4818 7.01289 17.4818 7.64766 16.8227L12.1875 12.1135L15.1023 15.1404C15.7371 15.7996 16.768 15.7996 17.4027 15.1404L23.9027 8.39043L23.8977 8.38516Z' fill='white' />
        </svg>
      )

    case 'heart-regular':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
          <path d='M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z' />
        </svg>
      )

    case 'heart-solid':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z' /></svg>
      )

    case 'award-solid':
      return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path d='M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z' /></svg>
      )

    default:
      return null
  }
}

export default Icon
